import type { Messages } from './en.js';

export const ptBR: Messages = {
  app: {
    name: 'Vammo Work',
    fixtureBanner: 'Ambiente de fixtures — dados de exemplo, sem integrações reais e sem mensagens reais.',
    skipToContent: 'Ir para o conteúdo',
  },
  nav: {
    documents: 'Documentos',
    myWork: 'Meu trabalho',
    requests: 'Solicitações',
    work: 'Trabalho',
    projects: 'Projetos',
    teams: 'Times',
    reports: 'Relatórios',
    admin: 'Administração',
    settings: 'Configurações',
    newRequest: 'Nova solicitação',
    newWork: 'Novo item de trabalho',
    search: 'Buscar',
    searchPlaceholder: 'Busque trabalho, solicitações e documentos ou digite uma chave…',
    notifications: 'Notificações',
    collapse: 'Recolher menu',
    expand: 'Expandir menu',
    openMenu: 'Abrir navegação',
    signOut: 'Sair',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    themeSystem: 'Sistema',
    autoTranslate: 'Tradução automática',
    language: 'Idioma',
    shortcuts: 'Atalhos de teclado',
    tutorial: 'Tutorial',
  },
  repoPicker: {
    workTitle: 'Repositórios vinculados',
    workHint: 'Vincular repositórios adiciona evidências para o trabalho futuro. Episódios concluídos mantêm sua base original.',
    projectTitle: 'Repositórios do projeto',
    projectHint: 'A reconciliação e a cobertura de captura incluem os repositórios anexados aqui.',
    search: 'Buscar repositórios',
    noneSelected: 'Nenhum repositório selecionado.',
    remove: 'Remover {{name}}',
    archived: 'Arquivado',
    edit: 'Editar repositórios',
  },
  translationReport: {
    action: 'Reportar',
    title: 'Reportar esta tradução',
    hint: 'Conte o que está errado. O texto original nunca é alterado.',
    comment: 'O que está errado? (opcional)',
    regenerate: 'Traduzir novamente',
    submit: 'Enviar relato',
    thanks: 'Obrigado, o relato foi registrado',
  },
  languageCorrection: {
    label: 'Idioma original',
    hint: 'Corrija se o texto foi detectado no idioma errado; as traduções são recriadas.',
  },
  conflict: {
    title: 'Outra pessoa salvou antes',
    hint: 'Compare sua alteração com a versão atual e escolha qual manter.',
    field: 'Campo',
    mine: 'Sua alteração',
    current: 'Versão atual',
    applyMine: 'Aplicar minha alteração',
    keepCurrent: 'Manter a versão atual',
    fields: { title: 'Título', descriptionMarkdown: 'Descrição', acceptanceCriteria: 'Critérios de aceitação', priority: 'Prioridade', assigneeId: 'Responsável', labels: 'Etiquetas', type: 'Tipo', originalLocale: 'Idioma original', repositoryIds: 'Repositórios', problemMarkdown: 'Problema', expectedOutcome: 'Resultado esperado' },
  },
  common: {
    removeItem: 'Remover {{name}}',
    viewPersonWork: 'Ver as tarefas de {{name}}',
    save: 'Salvar',
    saving: 'Salvando…',
    cancel: 'Cancelar',
    close: 'Fechar',
    create: 'Criar',
    edit: 'Editar',
    delete: 'Excluir',
    archive: 'Arquivar',
    confirm: 'Confirmar',
    submit: 'Enviar',
    back: 'Voltar',
    next: 'Avançar',
    retry: 'Tentar de novo',
    reload: 'Recarregar',
    loading: 'Carregando…',
    none: 'Nenhum',
    unassigned: 'Sem responsável',
    unknown: 'Desconhecido',
    optional: 'opcional',
    required: 'Obrigatório',
    yes: 'Sim',
    no: 'Não',
    all: 'Todos',
    me: 'Eu',
    filter: 'Filtrar',
    clearFilters: 'Limpar filtros',
    sort: 'Ordenar',
    openFullPage: 'Abrir página completa',
    copyLink: 'Copiar link',
    linkCopied: 'Link copiado',
    viewOriginal: 'Ver original',
    viewTranslation: 'Ver tradução',
    machineTranslated: 'Tradução automática do {{language}}',
    translating: 'Traduzindo…',
    translateItem: 'Traduzir',
    translateItemHint: 'Traduzir este item para o seu idioma',
    showOriginalItem: 'Ver original',
    translationFailed: 'Tradução indisponível; exibindo o original.',
    reportTranslation: 'Reportar tradução',
    noResults: 'Nenhum resultado',
    comingSoon: 'Ainda não disponível',
    reason: 'Motivo',
    reasonPlaceholder: 'Explique a decisão',
    created: 'Criado',
    updated: 'Atualizado',
    by: 'por {{name}}',
    you: 'você',
    changesSaved: 'Alterações salvas',
    actionFailed: 'A ação falhou',
    count_one: '{{count}} item',
    count_other: '{{count}} itens',
    preview: 'Pré-visualizar',
    write: 'Escrever',
    markdownHint: 'Markdown suportado: **negrito**, _itálico_, `código`, listas e links.',
    unsavedChanges: 'Você tem alterações não salvas. Salve ou cancele primeiro.',
    discard: 'Descartar',
    keepEditing: 'Continuar editando',
  },
  errors: {
    title: 'Algo deu errado',
    notFound: 'Não encontrado, ou você não tem acesso.',
    forbidden: 'Você não tem permissão para fazer isso.',
    unauthenticated: 'Sua sessão terminou. Entre novamente para continuar.',
    conflict: 'Outra pessoa alterou isto enquanto isso. Revise a versão mais recente e reaplique sua edição.',
    staleGeneration: 'Existe uma entrega mais recente. Revise o estado atual antes de responder.',
    rateLimited: 'Muitas solicitações. Aguarde um momento.',
    unavailable: 'Este recurso não está disponível agora.',
    offline: 'Você parece estar offline. As alterações não serão salvas até a conexão voltar.',
    validation: 'Corrija os campos destacados.',
    generic: 'Erro inesperado. Referência: {{correlationId}}',
  },
  auth: {
    signIn: 'Entrar com a Vammo',
    signingIn: 'Redirecionando para o login…',
    errorTitle: 'O login não foi concluído',
    errorState: 'O link de login expirou ou já foi usado. Comece de novo.',
    errorSuspended: 'Sua conta está suspensa. Fale com um administrador.',
    errorGeneric: 'Não conseguimos verificar seu login corporativo.',
    tryAgain: 'Tentar de novo',
  },
  status: {
    request: {
      DRAFT: 'Rascunho',
      SUBMITTED: 'Enviada',
      NEEDS_INFORMATION: 'Precisa de informações',
      ACCEPTED: 'Aceita',
      REJECTED: 'Recusada',
      DUPLICATE: 'Duplicada',
      RESOLVED: 'Resolvida',
      NEEDS_ATTENTION: 'Requer atenção',
      CANCELED: 'Cancelada',
    },
    phase: {
      TODO: 'A fazer',
      IN_PROGRESS: 'Em andamento',
      IN_REVIEW: 'Em revisão',
      INTEGRATED: 'Integrado',
      DONE: 'Concluído',
      CANCELED: 'Cancelado',
      EXPIRED: 'Expirada',
    },
    priority: { URGENT: 'Urgente', HIGH: 'Alta', NORMAL: 'Normal', LOW: 'Baixa' },
    workType: {
      FEATURE: 'Funcionalidade',
      BUG: 'Bug',
      MAINTENANCE: 'Manutenção',
      INFRASTRUCTURE: 'Infraestrutura',
      RESEARCH: 'Pesquisa',
      ANALYSIS: 'Análise',
      OPERATIONS: 'Operações',
      REVIEW: 'Revisão',
      OTHER: 'Outro',
      EPIC: 'Épico',
    },
    policy: { PRODUCTION: 'Entrega em produção', DELIVERABLE: 'Entregável', REVIEWED_DELIVERABLE: 'Entregável revisado' },
    policyHelp: {
      PRODUCTION: 'Concluído apenas quando todas as mudanças necessárias estiverem verificadas em produção.',
      DELIVERABLE: 'Concluído quando o responsável registra o resultado frente aos critérios.',
      REVIEWED_DELIVERABLE: 'Concluído quando um revisor independente aprova o resultado.',
    },
    delivery: { UNKNOWN: 'Entrega desconhecida', NOT_DEPLOYED: 'Não implantado', PARTIAL: 'Implantado parcialmente', DEPLOYED: 'Implantado', REVERTED: 'Revertido' },
    association: { CONFIRMED: 'Confirmado', PROVISIONAL: 'Provisório' },
    visibility: { COMPANY: 'Empresa', RESTRICTED: 'Restrito' },
    visibilityHelp: { COMPANY: 'Visível para todos os colaboradores da Vammo com login.', RESTRICTED: 'Visível apenas para as pessoas, times e grupos selecionados (e Superadmins).' },
    basis: { AGENT_REPORTED: 'Relatado por agente', HUMAN_REPORTED: 'Relatado', PROVIDER_VERIFIED: 'Verificado', IMPORTED_SOURCE: 'Importado', FIXTURE: 'Fixture' },
    completionBasis: { VERIFIED_PRODUCTION: 'Verificado em produção', DELIVERABLE: 'Entregável registrado', REVIEWED_DELIVERABLE: 'Revisado e aprovado', IMPORTED_SOURCE: 'Concluído no Jira (importado)', UNVERIFIED: 'Fechado sem evidência' },
    confirmation: { UNCONFIRMED: 'Aguardando sua confirmação', CONFIRMED: 'Confirmado como resolvido', PERSISTS: 'Ainda acontece' },
    fulfillment: {
      NOT_STARTED: 'Não iniciado',
      IN_PROGRESS: 'Em andamento',
      IN_REVIEW: 'Em revisão',
      AWAITING_DEPLOYMENT: 'Aguardando implantação em produção',
      AWAITING_ACTIVATION: 'Aguardando ativação',
      DELIVERED: 'Entregue',
      NONE_LINKED: 'Ainda não planejado',
    },
    channel: { WEB: 'Web', SLACK: 'Slack', MCP: 'Assistente de IA', API: 'API', EMAIL: 'E-mail', JIRA_IMPORT: 'Importação do Jira', SYSTEM: 'Sistema', VAMMO_APPS: 'Vammo Apps' },
    scope: { NONE: 'Não se aplica', AWAITING_SCOPE: 'Aguardando escopo de entrega', UNCONFIRMED: 'Escopo não confirmado', CONFIRMED: 'Escopo confirmado' },
    scopeAutomatic: 'Derivado do código vinculado e do mapeamento de serviços',
    scopeNotAffected: 'Não afetados por esta mudança',
    milestone: { START: 'Iniciado', SCOPE_CHANGE: 'Escopo alterado', BLOCKER: 'Bloqueio', VERIFICATION: 'Verificação', PR_UPDATE: 'Pull request', HANDOFF: 'Passagem', SESSION_END: 'Sessão encerrada', NOTE: 'Nota' },
    client: { CLAUDE_CODE: 'Claude Code', CODEX: 'Codex', CLAUDE: 'Claude', CHATGPT: 'ChatGPT', CLAWBOT: 'Clawbot (Slack)', OTHER: 'Outro cliente' },
  },
  actions: {
    request: {
      submit: 'Enviar solicitação',
      cancel: 'Cancelar solicitação',
      ask_information: 'Pedir informações',
      answer_information: 'Enviar resposta',
      accept: 'Aceitar',
      reject: 'Recusar',
      mark_duplicate: 'Marcar como duplicada',
      fulfill: 'Marcar como atendida',
      report_persistence: 'Informar que continua',
      fulfillment_invalidated: 'Reabrir para atenção',
      accept_correction: 'Aceitar correção',
      fulfill_after_review: 'Resolver após revisão',
      reconsider: 'Reconsiderar',
    },
    work: {
      start: 'Iniciar',
      request_review: 'Pedir revisão',
      request_changes: 'Pedir ajustes',
      integration_observed: 'Integrado',
      production_verified: 'Verificado em produção',
      complete_deliverable: 'Concluir',
      approve_deliverable: 'Aprovar',
      cancel: 'Cancelar trabalho',
      reopen: 'Reabrir',
      coverage_lost: 'Cobertura perdida',
      close_without_evidence: 'Fechar sem evidência',
      expire: 'Expirar',
    },
  },
  myWork: {
    title: 'Meu trabalho',
    greeting: 'Olá, {{name}}',
    subtitle: 'O que precisa da sua atenção hoje.',
    assigned: 'Atribuído a mim',
    assignedEmpty: 'Nada atribuído a você agora.',
    myRequests: 'Minhas solicitações',
    myRequestsEmpty: 'Você ainda não registrou solicitações.',
    needsMe: 'Aguardando você',
    needsMeEmpty: 'Nada está aguardando você.',
    blocked: 'Bloqueado',
    triageInbox: 'Caixa de triagem',
    updates: 'Atualizações recentes',
    updatesEmpty: 'Ainda não há atualizações.',
    following: 'Seguindo',
    followingEmpty: 'Siga trabalhos ou solicitações para vê-los aqui.',
    overdue: 'Atrasados',
    overdueEmpty: 'Nada seu está atrasado.',
    dueSoon: 'Vencem nos próximos 7 dias',
    dueSoonEmpty: 'Nada seu vence nesta semana.',
    stats: { open: 'Trabalho aberto', inReview: 'Em revisão', blocked: 'Bloqueados', attention: 'Solicitações que requerem atenção', overdue: 'Atrasados' },
  },
  requests: {
    move: { noProject: 'Sem projeto', title: 'Mover para {{name}}', hint: 'Mover muda quem pode ler esta solicitação, seus comentários e arquivos.', restrictedAfter: 'Após mover, a solicitação ficará restrita ao público do projeto.', companyAfter: 'Após mover, a solicitação ficará visível para toda a empresa.', losesAccess: 'Estas pessoas perderiam acesso:', nobodyLoses: 'Ninguém envolvido perde acesso.', reassignFirst: 'O responsável perderia acesso. Reatribua a solicitação primeiro.', confirm: 'Mover solicitação' },
    activation: { pending: 'Ativação pendente:', observed: 'Ativação observada por {{name}} em {{time}}', notRequired: 'Não requer uma ativação separada.', require: 'Exigir ativação', record: 'Registrar ativação', waive: 'Dispensar ativação', requireHint: 'Use quando implantar não basta, por exemplo quando um feature flag precisa ser ligado. A solicitação fica aceita até registrar a ativação.', recordHint: 'Registre quem observou a mudança ativa e a evidência. Fica auditado.', waiveHint: 'A ativação deixará de ser obrigatória. O motivo fica auditado.', noteLabel: 'O que precisa ser ativado?', evidenceLabel: 'Evidência', reasonLabel: 'Motivo' },
    duplicates: { title: 'Possíveis duplicatas', hint: 'Solicitações semelhantes que você pode ver. Ao marcar, cada solicitante continua informado.', mark: 'Marcar como duplicata desta' },
    title: 'Solicitações',
    subtitle: 'Problemas, ideias e pedidos de toda a Vammo.',
    tabs: { inbox: 'Entrada', mine: 'Minhas', attention: 'Requer atenção', following: 'Seguindo', all: 'Todas', snoozed: 'Adiadas' },
    empty: 'Nenhuma solicitação aqui.',
    emptyInbox: 'A caixa de entrada está vazia. Novas solicitações aparecem aqui para triagem.',
    columns: { key: 'Chave', title: 'Título', status: 'Status', priority: 'Prioridade', author: 'Solicitante', assignee: 'Responsável', team: 'Time', updated: 'Atualizado', created: 'Criado', source: 'Origem' },
    snooze: {
      action: 'Adiar',
      title: 'Adiar solicitação',
      hint: 'Sai da caixa de triagem e volta sozinha no momento escolhido. Qualquer mudança de status a traz de volta antes.',
      until: 'Adiar até',
      tomorrow: 'Amanhã de manhã',
      nextWeek: 'Na próxima segunda',
      inTwoWeeks: 'Em duas semanas',
      custom: 'Escolher uma data',
      badge: 'Adiada até {{time}}',
      wake: 'Reativar agora',
      snoozedToast: 'Adiada até {{time}}',
      wokenToast: 'De volta à caixa de entrada',
    },
    detail: {
      problem: 'Problema',
      currentBehavior: 'O que acontece hoje',
      expectedOutcome: 'Resultado esperado',
      impact: 'Impacto',
      impactUnknown: 'Impacto ainda desconhecido',
      reproduction: 'Como reproduzir',
      affectedArea: 'Área afetada',
      progress: 'Progresso',
      decisions: 'Histórico de decisões',
      comments: 'Comentários',
      linkedWork: 'Trabalho vinculado',
      linkedWorkEmpty: 'Nenhum trabalho vinculado ainda.',
      required: 'Obrigatório',
      optional: 'Opcional',
      hiddenWork: 'Parte do trabalho vinculado é restrita e não é exibida.',
      pendingQuestion: 'O time perguntou',
      answerPlaceholder: 'Responda à pergunta…',
      duplicateOf: 'Duplicada de',
      decisionReason: 'Nota da decisão',
      source: 'Origem',
      triage: 'Triagem',
      triageTeam: 'Time de triagem',
      followers: 'Seguir',
      following: 'Seguindo',
      linkWork: 'Vincular trabalho',
      linkWorkSearch: 'Busque trabalho por chave ou título',
      unlink: 'Desvincular',
    },
    confirm: {
      fromEmail: 'Escolha sua resposta abaixo. Nada é registrado até você clicar.',
      title: 'Isto foi resolvido para você?',
      body: 'O time marcou esta solicitação como resolvida. Diga se funcionou para você.',
      confirmed: 'Sim, está resolvido',
      persists: 'Não, ainda acontece',
      commentPlaceholder: 'Adicione detalhes (opcional)',
      thanks: 'Obrigado por confirmar.',
      reported: 'Obrigado — o time vai revisar novamente.',
      generation: 'Entrega nº {{generation}}',
    },
    dialogs: {
      rejectTitle: 'Recusar solicitação',
      duplicateTitle: 'Marcar como duplicada',
      duplicateSearch: 'Encontre a solicitação principal',
      askTitle: 'Pedir informações',
      askPlaceholder: 'O que você precisa saber?',
      fulfillTitle: 'Marcar como atendida',
      fulfillDirect: 'Descreva o resultado entregue',
      reviewTitle: 'Resolver após revisão',
      reviewPlaceholder: 'Explique por que o resultado atual agora atende à solicitação',
      correctionTitle: 'Aceitar correção',
      correctionWork: 'Item de trabalho corretivo (opcional)',
      cancelTitle: 'Cancelar solicitação',
      reconsiderTitle: 'Reconsiderar solicitação',
    },
  },
  comments: {
    react: 'Adicionar reação',
    summary: { action: 'Resumir a discussão', title: 'Resumo com IA', again: 'Gerar de novo', note: 'Feito com IA a partir dos {{count}} comentários que você pode ver. Pode errar; a fonte é a conversa.' },
    reactedBy: '{{names}} reagiu com {{reaction}}',
    reactions: { THUMBS_UP: 'joinha', THUMBS_DOWN: 'polegar para baixo', LAUGH: 'risada', HOORAY: 'comemoração', CONFUSED: 'confusão', HEART: 'coração', ROCKET: 'foguete', EYES: 'olhos' },
    mentionPeople: 'Mencionar alguém',
    mentionHint: 'Digite @ para mencionar alguém; a pessoa recebe uma notificação.',
  },
  labels: {
    title: 'Etiquetas',
    manage: 'Gerenciar etiquetas…',
    hint: 'Dê a cada etiqueta uma cor e uma descrição. As que não têm aparecem em cinza; excluir uma só remove a cor, nunca a etiqueta dos itens de trabalho.',
    name: 'Etiqueta',
    color: 'Cor',
    description: 'Descrição (opcional)',
    add: 'Salvar etiqueta',
    saved: 'Etiqueta salva',
    delete: 'Excluir a cor de {{name}}',
    empty: 'Nenhuma etiqueta tem cor ainda.',
    colors: { gray: 'Cinza', red: 'Vermelho', orange: 'Laranja', amber: 'Amarelo', green: 'Verde', teal: 'Verde-azulado', blue: 'Azul', indigo: 'Índigo', purple: 'Roxo', pink: 'Rosa' },
  },
  inbox: {
    title: 'Caixa de entrada',
    subtitle: 'Novidades do trabalho e das solicitações em que você participa.',
    tabs: { inbox: 'Todas', mentions: 'Menções', unread: 'Não lidas', snoozed: 'Adiadas', archived: 'Arquivadas' },
    empty: { inbox: 'Você está em dia.', mentions: 'Ninguém mencionou você ainda.', unread: 'Nada não lido.', snoozed: 'Nada adiado.', archived: 'Nada arquivado.' },
    markAllRead: 'Marcar tudo como lido',
    allRead: 'Tudo marcado como lido',
    archiveRead: 'Arquivar lidas',
    archivedRead: 'Notificações lidas arquivadas',
    markRead: 'Marcar como lida',
    archive: 'Arquivar',
    unarchive: 'Voltar para a caixa',
    snooze: 'Adiar',
    snoozeFor: { day: 'Até amanhã', threeDays: 'Por 3 dias', week: 'Por uma semana' },
    snoozed: 'Adiada',
    unsnooze: 'Trazer agora',
    snoozedUntil: 'adiada até {{time}}',
    unread: 'Não lida',
    unreadCount_one: '{{count}} não lida',
    unreadCount_other: '{{count}} não lidas',
    actions: 'Ações da notificação',
  },
  templates: {
    use: 'Começar de um modelo…',
    manage: 'Gerenciar',
    manageWork: 'Modelos de trabalho',
    manageRequest: 'Modelos de solicitação',
    saveAs: 'Salvar como modelo',
    saveTitle: 'Salvar como modelo',
    saveHintWork: 'Salva o título, tipo, prioridade, descrição, critérios, etiquetas e subitens para o próximo item começar deles.',
    saveHintRequest: 'Salva o texto da solicitação para a próxima começar dele.',
    name: 'Nome do modelo',
    description: 'Descrição (opcional)',
    onlyThisProject: 'Oferecer só neste projeto',
    saved: 'Modelo salvo',
    everywhere: 'Todos os projetos',
    remove: 'Remover o modelo {{name}}',
    empty: 'Ainda não há modelos. Salve um a partir de um formulário ou de um item de trabalho.',
    subItems_one: 'Cria {{count}} subitem',
    subItems_other: 'Cria {{count}} subitens',
  },
  intake: {
    title: 'Nova solicitação',
    subtitle: 'Descreva o que está acontecendo. Você não precisa saber como resolver.',
    tabs: { assistant: 'Guiado', form: 'Formulário' },
    assistantIntro: 'Conte o problema ou a ideia com suas palavras. Vou perguntar só o que faltar.',
    assistantPlaceholder: 'Digite sua resposta…',
    assistantUnavailable: 'O assistente está indisponível agora. Use o formulário; tudo fica salvo.',
    assistant: {
      ack: 'Obrigado, salvei isso no rascunho.',
      askProblem: 'O que está acontecendo, e onde?',
      askExpected: 'O que deveria acontecer?',
      askImpact: 'Quem é afetado e quanto isso importa? Tudo bem dizer que não sabe.',
      askReproduction: 'Se for um bug: como alguém consegue ver o problema acontecer, e com que frequência?',
      ready: 'Já tenho o que a triagem precisa. Revise o resumo e envie quando estiver certo.',
      fallback: 'O assistente está indisponível, então salvei sua resposta como está.',
    },
    fields: {
      title: 'Título curto',
      titlePlaceholder: 'ex.: O app não mostra o histórico de trocas',
      problem: 'Qual é o problema?',
      problemPlaceholder: 'Descreva a situação e quem é afetado',
      currentBehavior: 'O que acontece hoje?',
      expectedOutcome: 'O que deveria acontecer?',
      impact: 'Impacto',
      impactPlaceholder: 'Quem ou o que é afetado, e quanto?',
      impactUnknown: 'Ainda não sei o impacto',
      reproduction: 'Passos para reproduzir (para bugs)',
      affectedArea: 'Área ou produto afetado',
      language: 'Escrito em',
      visibility: 'Quem pode ver',
      team: 'Encaminhar ao time',
      teamAuto: 'Deixar a triagem decidir',
      priority: 'Prioridade',
      evidence: 'Anexos',
    },
    duplicates: 'Solicitações possivelmente relacionadas',
    duplicatesHelp: 'Verifique se alguma delas já cobre sua solicitação.',
    review: 'Revisar e enviar',
    reviewHelp: 'Confira o resumo abaixo. Você ainda pode editar antes de enviar.',
    missing: 'Ainda falta: {{fields}}',
    saved: 'Rascunho salvo',
    submitted: 'Solicitação {{key}} enviada',
    draftNote: 'Rascunhos são privados até você enviá-los.',
  },
  work: {
    title: 'Trabalho',
    defectCause: {
      title: 'Causa',
      causedBy: 'Causado por',
      causedByHelp: 'O trabalho entregue que introduziu este bug (até 5).',
      none: 'Sem causa de entrega',
      noneHelp: 'Nenhuma entrega causou o bug.',
      category: 'Categoria',
      note: 'Observação',
      notePlaceholder: 'O que aconteceu?',
      reasons: { PRE_EXISTING: 'Pré-existente', EXTERNAL: 'Externo ou fornecedor', CONFIGURATION: 'Configuração', DATA: 'Dados', OTHER: 'Outro' },
      search: 'Buscar o trabalho que causou o bug',
      notInformed: 'Causa não informada',
      notInformedHint: 'Diga qual trabalho causou este bug, ou que nenhuma entrega o causou.',
      inform: 'Informar causa',
      change: 'Alterar',
      changeTitle: 'Alterar causa',
      clear: 'Limpar',
      saved: 'Causa salva',
      noDeliveryCause: 'Sem causa de entrega: {{reason}}',
    },
    subtitle: 'Tudo em andamento entre times, projetos e repositórios.',
    views: { list: 'Lista', board: 'Quadro' },
    empty: 'Nenhum trabalho corresponde a esses filtros.',
    columns: { key: 'Chave', title: 'Título', phase: 'Fase', priority: 'Prioridade', type: 'Tipo', assignee: 'Responsável', project: 'Projeto', team: 'Time', updated: 'Atualizado', delivery: 'Entrega', labels: 'Etiquetas', created: 'Criado', owner: 'Dono', start: 'Início', due: 'Prazo', points: 'Pontos' },
    filters: { phase: 'Fase', type: 'Tipo', priority: 'Prioridade', assignee: 'Responsável', project: 'Projeto', team: 'Time', blocked: 'Somente bloqueados', provisional: 'Somente provisórios', includeCanceled: 'Incluir cancelados', label: 'Etiqueta', archived: 'Somente arquivados', due: 'Prazo', dueOverdue: 'Atrasados', dueSoon: 'Vencem nos próximos 7 dias', dueNone: 'Sem prazo' },
    bulk: { selected: '{{count}} selecionados', setPriority: 'Definir prioridade', assign: 'Atribuir', addLabel: 'Adicionar etiqueta', clear: 'Limpar seleção', setProject: 'Mover para projeto', noProject: 'Sem projeto', setTeam: 'Definir time', removeLabel: 'Remover etiqueta', labelPlaceholder: 'Etiqueta', archive: 'Arquivar', restore: 'Restaurar', setDue: 'Definir prazo', clearDue: 'Remover prazo', cancel: 'Cancelar trabalho', cancelTitle: 'Cancelar {{count}} itens de trabalho', cancelHint: 'Todos os itens selecionados são cancelados com este motivo.' },
    columnsMenu: { title: 'Colunas', reset: 'Mostrar colunas padrão' },
    export: { title: 'Exportar', csv: 'Arquivo CSV', xlsx: 'Arquivo do Excel (.xlsx)', hint: 'Baixa os filtros atuais, até 5000 linhas.' },
    groupBy: 'Agrupar',
    groupNone: 'Sem agrupar',
    lanes: 'Linhas',
    lanesNone: 'Sem linhas',
    closedWindow: { label: 'Encerradas', days: 'Encerradas: últimos {{count}} dias', all: 'Encerradas: todas' },
    groupFields: { phase: 'Fase', priority: 'Prioridade', assignee: 'Responsável', project: 'Projeto', team: 'Time', type: 'Tipo', label: 'Etiqueta' },
    groups: { noProject: 'Sem projeto', noTeam: 'Sem time', noLabel: 'Sem etiqueta' },
    board: { moveTo: 'Mover para…', dropRejected: 'Esse movimento não é permitido: {{reason}}', productionHint: 'Trabalho de produção só fica Concluído com implantações verificadas.' },
    create: {
      title: 'Novo item de trabalho',
      responsibility: 'Responsável',
      team: 'Time',
      personal: 'Pessoal (eu)',
      project: 'Projeto',
      noProject: 'Sem projeto',
      type: 'Tipo',
      policy: 'Conclusão',
      description: 'Descrição',
      criteria: 'Critérios de aceite',
      addCriterion: 'Adicionar critério',
      criterionPlaceholder: 'Resultado observável…',
      assignee: 'Responsável',
      labels: 'Etiquetas',
      labelsPlaceholder: 'separadas, por vírgula',
      startDate: 'Data de início',
      dueDate: 'Prazo',
      created: '{{key}} criado',
    },
    provisional: {
      confirm: 'Confirmar como trabalho novo',
      merge: 'Mesclar com trabalho existente',
      mergeTitle: 'Mesclar com trabalho existente',
      mergeHint: 'A chave vira um alias do item escolhido. Contribuições, sessões, pull requests e vínculos com solicitações são transferidos; nada é apagado.',
      mergeInto: 'Mesclar com {{key}}',
      confirmed: 'Confirmado como trabalho novo',
      merged: 'Mesclado com {{key}}',
    },
    detail: {
      overview: 'Visão geral',
      activity: 'Atividade',
      progress: 'Progresso',
      delivery: 'Entrega',
      code: 'Código',
      codeTab: {
        pullRequests: 'Pull requests',
        commits: 'Commits',
        evidence: 'Links reportados por agentes',
        noPullRequests: 'Nenhum pull request vinculado.',
        noCommits: 'Nenhum commit vinculado.',
        linkLabel: 'Vincular um commit ou pull request',
        linkHint: 'Cole a URL do GitHub. Commits e pull requests que mencionam {{key}} se vinculam sozinhos.',
        link: 'Vincular',
        linkedCommit: 'Commit vinculado',
        linkedPr: 'Pull request vinculado',
        unlink: 'Desvincular',
        unlinked: 'Vínculo removido',
        viaKey: 'Pela chave',
        viaVammoApps: 'Pelo Vammo Apps',
        manual: 'Vinculado manualmente',
        prState: {
          OPEN: 'Aberto',
          CLOSED: 'Fechado',
          MERGED: 'Mesclado',
        },
        errors: {
          not_connected: 'Esse repositório não está conectado. Instale primeiro a GitHub App nele.',
          not_synced: 'Esse pull request ainda não foi sincronizado. Associe o repositório a um projeto e tente de novo em alguns minutos.',
          not_found: 'Não existe um commit com esse SHA no repositório.',
          unsupported: 'Cole a URL de um commit ou pull request do GitHub.',
          invalid_format: 'Cole a URL de um commit ou pull request do GitHub.',
        },
      },
      history: 'Histórico',
      description: 'Descrição',
      noDescription: 'Ainda sem descrição.',
      criteria: 'Critérios de aceite',
      noCriteria: 'Sem critérios de aceite.',
      properties: 'Propriedades',
      owner: 'Dono',
      reviewer: 'Revisor',
      repositories: 'Repositórios',
      noRepositories: 'Sem repositórios — tudo bem para trabalho sem código.',
      labels: 'Etiquetas',
      blockers: 'Bloqueios',
      addBlocker: 'Adicionar bloqueio',
      blockerReason: 'O que está bloqueando?',
      preventsCompletion: 'Impede a conclusão',
      resolveBlocker: 'Resolver',
      relations: 'Trabalho relacionado',
      addRelation: 'Vincular trabalho',
      relationKinds: { PARENT_OF: 'Pai de', DEPENDS_ON: 'Depende de', RELATES_TO: 'Relacionado a', DUPLICATES: 'Duplica', CAUSED_BY: 'Causado por' },
      defect: 'Defeito',
      requiresCompletion: 'Necessário para concluir',
      contributors: 'Contribuidores',
      linkedRequests: 'Solicitações',
      outcome: 'Resultado',
      outcomePlaceholder: 'O que foi entregue?',
      complete: 'Concluir entregável',
      criterionStatus: { OPEN: 'Aberto', MET: 'Atendido', NOT_MET: 'Não atendido', WAIVED: 'Dispensado' },
      episodes: 'Episódios de conclusão',
      provisionalNote: 'Criado provisoriamente por um agente; confirme ou mescle.',
      blockedNote: 'Bloqueado',
      awaitingDeployment: 'Aguardando verificação da implantação',
      sessions: 'Sessões de agentes',
      evidence: 'Evidências',
      noEvidence: 'Nenhuma evidência anexada.',
      archivedBanner: 'Arquivado {{time}}. Restaure para fazer alterações.',
      archive: 'Arquivar',
      unarchive: 'Restaurar',
      archivedToast: 'Item de trabalho arquivado',
      restoredToast: 'Item de trabalho restaurado',
      delete: 'Excluir definitivamente',
      deleteTitle: 'Excluir {{key}} definitivamente?',
      deleteHint: 'Remove o item de trabalho com seus comentários, anexos, traduções e progresso. O registro de auditoria guarda um registro com o seu motivo. Não pode ser desfeito.',
      deleteConfirm: 'Digite {{key}} para confirmar',
      deletedToast: '{{key}} excluído',
      addSubItem: 'Adicionar subitem',
      subItemOf: 'Subitem de {{key}}',
      copyBranch: 'Copiar nome da branch',
      branchCopied: 'Nome da branch copiado: {{branch}}',
      copyKey: 'Copiar chave',
      keyCopied: '{{key}} copiada',
      editLabels: 'Editar etiquetas',
      labelsPlaceholder: 'Digite uma etiqueta e pressione Enter',
      noLabels: 'Sem etiquetas',
      shortcuts: { title: 'Atalhos de teclado', priority: 'Alterar prioridade', assign: 'Alterar responsável', assignMe: 'Atribuir a mim', labels: 'Editar etiquetas', copyKey: 'Copiar chave' },
      startDate: 'Data de início',
      dueDate: 'Prazo',
      overdue: 'Atrasado',
      dueToday: 'Vence hoje',
      clearDate: 'Remover data',
      subItems: 'Subitens',
      noSubItems: 'Ainda sem subitens.',
      unlinkSubItem: 'Remover dos subitens',
      parents: 'Itens pai',
      progressOf: '{{done}} de {{total}} concluídos',
      timelineEmpty: 'Ainda sem histórico.',
    },
  },
  projects: {
    slack: {
      title: 'Novidades no Slack',
      hint: 'Escolha o canal do Slack onde as novidades deste projeto são publicadas, e quais. Os responsáveis pelo projeto e os administradores podem alterar.',
      notConnected: 'O Slack não está conectado neste ambiente.',
      listFailed: 'O Slack não retornou seus canais agora; tente de novo em um minuto.',
      channel: 'Canal',
      none: 'Nenhum canal',
      private: 'privado',
      notMember: 'O app ainda não está em #{{channel}}. Convide-o no Slack com /invite @Vammo Work Tracker; caso contrário, as novidades não são publicadas.',
      replaces_one: 'Um administrador configurou {{count}} canal; ao salvar, fica só o escolhido aqui.',
      replaces_other: 'Um administrador configurou {{count}} canais; ao salvar, fica só o escolhido aqui.',
      workEvents: 'Tarefas',
      requestEvents: 'Solicitações',
      save: 'Salvar canal do Slack',
      saved: 'Canal do Slack salvo',
      removed: 'O projeto não publica mais no Slack',
    },
    vammoApps: {
      tabs: { STANDARD: 'Projetos', VAMMO_APP: 'Vammo Apps' },
      badge: 'Vammo App',
      open: 'Abrir no Vammo Apps',
      hint: 'Um projeto para cada app da plataforma Vammo Apps. Cada pedido de deploy é um trabalho que se conclui sozinho quando roda em produção.',
      empty: 'Ainda não há Vammo Apps.',
      managed: 'Sincronizado com a plataforma Vammo Apps: os trabalhos seguem os pedidos de deploy e os deploys deste app.',
    },
    activity: {
      subtitle: 'Trabalho, entregas e participação em cada projeto.',
      search: 'Buscar projetos por nome ou chave…',
      includeArchived: 'Incluir arquivados',
      noResults: 'Nenhum projeto corresponde à busca.',
      loaded: '{{count}} projetos carregados',
      weekHint: 'Esta semana · desde segunda-feira · {{timezone}}',
      scopeHint:
        'As contagens respeitam seu acesso. Commits e deploys bem-sucedidos em produção correspondem aos repositórios vinculados e podem se repetir entre projetos. Apenas a atividade registrada é mostrada; dados ausentes não são zero.',
      openProject: 'Abrir {{name}}',
      archived: 'Arquivado',
      repositoryCount_one: "{{count}} repositório",
      repositoryCount_other: "{{count}} repositórios",
      lastActivity: 'Última atividade',
      noActivity: 'Ainda sem atividade registrada',
      open: 'Tarefas abertas',
      inProgress: '{{count}} em andamento',
      blocked_one: "{{count}} bloqueada",
      blocked_other: "{{count}} bloqueadas",
      openHint:
        'Tarefas atuais não arquivadas que você pode acessar, excluindo concluídas, canceladas e expiradas. Cada tarefa bloqueada é contada uma vez.',
      completed: 'Concluídas',
      thisWeek: 'Esta semana',
      imported_one: "+ {{count}} importada",
      imported_other: "+ {{count}} importadas",
      completedHint:
        'Tarefas distintas com uma conclusão nesta semana, incluindo as reabertas depois. Conclusões repetidas contam uma vez. Exclui tarefas canceladas, expiradas, arquivadas e provisórias. Conclusões importadas aparecem separadamente; concluir não significa necessariamente entrega verificada em produção.',
      commits: 'Commits',
      deployments: 'Deploys',
      commitsHint:
        'Commits registrados nos repositórios vinculados ao projeto, pela data original. Repositórios compartilhados podem aparecer em vários projetos. A sincronização não garante o histórico completo.',
      deploymentsHint:
        'Deploys bem-sucedidos em produção dos serviços mapeados aos repositórios do projeto, pela data de conclusão. Exclui falhas, rollbacks e deploys sem data de conclusão. É atividade do serviço, não prova de entrega de todas as tarefas do projeto.',
      activePeople: 'Pessoas ativas',
      peopleHint:
        'Contas ativas distintas que alteraram tarefas visíveis, comentaram nelas ou atualizaram o projeto nesta semana. Inclui agentes agindo por uma pessoa verificada. Importações históricas, eventos do sistema e pessoas apenas atribuídas não contam. É atividade, não presença online ou medida de produtividade.',
      lastSync: 'Última sincronização bem-sucedida: {{date}}.',
      coverage: {
        PARTIAL: 'Registrados · parcial',
        FIXTURE: 'Dados de teste',
        UNAVAILABLE: 'Sem dados sincronizados',
        UNMAPPED: 'Sem vínculo',
        FORBIDDEN: 'Restrito',
      },
    },
    automation: {
      title: 'Regras automáticas',
      hint: 'Aplicadas a cada hora ao trabalho deste projeto. Deixe um campo vazio para desligar a regra.',
      staleAfter: 'Sem atividade por (dias)',
      staleAction: 'Então',
      actions: { NOTIFY: 'Avisar o responsável', CANCEL: 'Cancelar (o que uma solicitação exige só recebe aviso)' },
      autoArchive: 'Arquivar o concluído após (dias)',
      autoArchiveHint: 'O concluído ou cancelado sai das listas; continua encontrável em Arquivados.',
      off: 'Desligada',
    },
    updates: {
      title: 'Status do projeto',
      statusLabel: 'Status do projeto',
      status: { ON_TRACK: 'No caminho', AT_RISK: 'Em risco', OFF_TRACK: 'Fora do caminho' },
      placeholder: 'O que mudou, o que está em risco, o que vem a seguir?',
      post: 'Publicar status',
      posted: 'Status publicado',
      empty: 'Ainda não há atualizações de status.',
      edited: 'editado',
      reply: 'Responder',
      replyPlaceholder: 'Escreva uma resposta…',
    },
    addManager: 'Adicionar gestor',
    addTeam: 'Adicionar time responsável',
    archive: 'Arquivar este projeto',
    archiveHint: 'Projetos arquivados saem de listas e seletores; seus trabalhos e histórico continuam visíveis.',
    title: 'Projetos',
    subtitle: 'Projetos agrupam trabalho; repositórios são opcionais.',
    new: 'Novo projeto',
    empty: 'Ainda não há projetos.',
    key: 'Chave',
    name: 'Nome',
    description: 'Descrição',
    managers: 'Gestores',
    owningTeams: 'Times responsáveis',
    openWork: '{{count}} abertos',
    defaultPolicy: 'Conclusão padrão',
    requiresReview: 'Exigir revisão independente para entregáveis',
    settings: 'Configurações',
    visibility: 'Visibilidade',
    repositories: 'Repositórios',
  },
  teams: {
    title: 'Times',
    members: 'Membros',
    manager: 'Gestor',
    member: 'Membro',
    addMember: 'Adicionar membro',
    remove: 'Remover',
    new: 'Novo time',
    slug: 'Identificador',
    archive: 'Arquivar time',
    restore: 'Restaurar time',
    archived: 'Time arquivado',
    restored: 'Time restaurado',
    archivedBadge: 'Arquivado',
    archiveHint: 'Oculta o time de listas e seletores. Antes, mova seus projetos, trabalho aberto e solicitações abertas para outro time.',
  },
  documents: {
    title: 'Documentos',
    subtitle: 'Documentação da empresa em pastas, com quem vê e quem edita definido por pasta.',
    folders: 'Pastas',
    moreActions: 'Mais ações',
    archiveLink: 'Arquivados',
    archiveTitle: 'Documentos e pastas arquivados',
    archiveHint: 'O que está arquivado mantém o conteúdo e o histórico. Os editores da pasta restauram.',
    archiveEmpty: 'Nada arquivado.',
    restore: 'Restaurar',
    restoredItem: 'Restaurado',
    resizeTree: 'Mudar a largura do painel de pastas',
    moveNotAllowed: 'Você não pode mover para lá',
    dropToRoot: 'Solte aqui para deixar no primeiro nível',
    open: 'Abrir',
    copyLink: 'Copiar link',
    linkCopied: 'Link copiado',
    changeIcon: 'Mudar ícone',
    removeIcon: 'Remover ícone',
    iconSaved: 'Ícone atualizado',
    permissions: 'Permissões',
    renameDocument: 'Renomear documento',
    documentTitle: 'Título do documento',
    export: 'Exportar',
    exportPdf: 'PDF (imprimir ou salvar)',
    exportMarkdown: 'Markdown (.md)',
    exportHtml: 'Página web (.html)',
    exportWord: 'Word (.docx)',
    exporting: 'Preparando a exportação…',
    linkTitle: 'Link',
    linkTabUrl: 'Endereço web',
    linkTabDocument: 'Documento',
    linkTabTask: 'Tarefa',
    linkUrl: 'Endereço',
    searchDocuments: 'Busque documentos pelo título',
    searchTasks: 'Busque tarefas pelo título ou chave',
    removeLink: 'Remover link',
    applyLink: 'Aplicar',
    noMatches: 'Nenhum resultado',
    mentionInvite: 'Convidar {{email}}',
    mentionEmpty: 'Digite um nome, ou um email da empresa para convidar alguém',
    mentionInvited: '{{name}} verá a menção ao entrar pela primeira vez',
    insertMedia: 'Imagem ou vídeo',
    uploadingMedia: 'Enviando {{name}}…',
    mediaFailed: 'Não foi possível enviar {{name}}',
    mediaType: 'Documentos aceitam só imagens (PNG, JPEG, GIF, WebP) e vídeos (MP4, WebM, MOV)',
    comments: 'Comentários',
    comment: 'Comentar',
    addComment: 'Adicionar comentário',
    commentPlaceholder: 'Escreva um comentário. Use @ para mencionar alguém.',
    reply: 'Responder',
    replyPlaceholder: 'Responder…',
    resolve: 'Resolver',
    reopen: 'Reabrir',
    resolvedBy: 'Resolvido por {{name}}',
    showResolved: 'Mostrar resolvidos',
    detached: 'O texto comentado mudou ou foi removido',
    noComments: 'Selecione texto do documento para comentar.',
    editComment: 'Editar',
    deleteComment: 'Apagar',
    deleteCommentConfirm: 'Apagar este comentário?',
    edited: 'editado',
    expandFolder: 'Expandir {{name}}',
    collapseFolder: 'Recolher {{name}}',
    newFolder: 'Nova pasta',
    newSubfolder: 'Nova subpasta',
    newDocument: 'Novo documento',
    untitled: 'Sem título',
    folderName: 'Nome da pasta',
    rename: 'Renomear',
    renamed: 'Renomeado',
    archiveFolder: 'Arquivar pasta',
    archiveFolderHint: 'Só pastas vazias podem ser arquivadas. Primeiro arquive ou mova os documentos e as subpastas dela.',
    archiveDocument: 'Arquivar documento',
    restoreDocument: 'Restaurar documento',
    archived: 'Arquivado',
    archivedNotice: 'Este documento está arquivado. Restaure-o para editar de novo.',
    emptyTree: 'Ainda não há pastas',
    emptyTreeHint: 'Crie uma pasta para começar a organizar documentos. Você vira o primeiro editor dela.',
    emptyFolder: 'Esta pasta está vazia.',
    subfolders: 'Subpastas',
    documentsHeading: 'Documentos',
    pickFolder: 'Escolha uma pasta ou um documento à esquerda.',
    documentCount_one: '{{count}} documento',
    documentCount_other: '{{count}} documentos',
    restricted: 'Restrita',
    company: 'Toda a empresa',
    canEdit: 'Você pode editar',
    readOnly: 'Somente leitura',
    updatedBy: 'Editado por {{name}}',
    access: 'Acesso',
    accessTitle: 'Quem vê e quem edita',
    viewers: 'Quem pode ver',
    viewersCompany: 'Toda a empresa',
    viewersCompanyHelp: 'Todos que veem a pasta acima (numa pasta de primeiro nível, qualquer pessoa da Vammo com sessão iniciada).',
    viewersRestricted: 'Só as pessoas, times, grupos e projetos abaixo',
    viewersRestrictedHelp: 'Uma subpasta só pode restringir o público da pasta acima. Os editores desta lista também veem. Superadmins sempre veem tudo.',
    editors: 'Quem pode editar',
    editInherit: 'Igual à pasta acima',
    editViewers: 'Todos que podem ver',
    editListed: 'Só as pessoas, times, grupos e projetos abaixo',
    editsFrom: 'Os editores vêm de “{{folder}}”.',
    everyoneWhoViews: 'Todos que veem podem editar.',
    addPrincipal: 'Adicionar pessoas, times, grupos ou projetos',
    removePrincipal: 'Remover {{name}}',
    accessSaved: 'Acesso atualizado',
    principalKind: { USER: 'Pessoa', TEAM: 'Time', GROUP: 'Grupo', PROJECT: 'Projeto' },
    saving: 'Salvando…',
    saved: 'Salvo',
    unsaved: 'Alterações não salvas',
    saveFailed: 'Não foi possível salvar. Suas alterações continuam aqui; tentando de novo…',
    conflictTitle: 'Outra pessoa salvou este documento',
    conflictBody: 'Suas últimas alterações não foram salvas porque o documento mudou. Copie o que quiser manter e recarregue para ver a versão mais recente.',
    reload: 'Recarregar',
    alsoEditing: 'Também editando: {{names}}',
    placeholder: 'Escreva aqui. Use a barra de ferramentas ou atalhos de Markdown como # ou -.',
    titlePlaceholder: 'Título',
    bodyLabel: 'Conteúdo do documento',
    lock: 'Tornar rascunho privado',
    lockEdit: 'Ajustes do rascunho privado',
    unlock: 'Destravar',
    locked: 'Rascunho privado',
    lockHelp: 'Um rascunho privado só é visto por você e pelas pessoas que você indicar. Elas ainda precisam de acesso à pasta. Ao destravar, o documento volta a ter as permissões da pasta.',
    lockPeople: 'Pessoas que também veem o rascunho',
    lockAddPerson: 'Adicionar uma pessoa',
    lockWarning: 'Estas pessoas não veem a pasta, então ainda não conseguem abrir o rascunho: {{names}}',
    lockSaved: 'Ajustes do rascunho salvos',
    unlocked: 'O documento agora tem as permissões da pasta',
    history: 'Histórico',
    historyEmpty: 'Ainda não há revisões.',
    revisionN: 'Revisão {{n}}',
    revisionKind: { CREATE: 'Criado', EDIT: 'Editado', RESTORE: 'Restaurado' },
    restoredFrom: 'Restaurado da revisão {{n}}',
    viaAgent: 'via {{client}}',
    restoreRevision: 'Restaurar esta versão',
    restoreConfirm: 'Restaurar a revisão {{n}}? Ela é salva como uma nova revisão, então nada se perde.',
    restored: 'Revisão restaurada',
    adminAccesses: 'Acessos de Superadmins',
    adminAccessesHelp: 'Superadmins que abriram este documento sem fazer parte do público dele.',
    move: 'Mover',
    moveTo: 'Mover para a pasta',
    moved: 'Movido',
    topLevel: 'Primeiro nível',
    chipRestricted: 'Documento restrito',
    commentOnPage: 'Comentar o documento',
    pageComment: 'Sobre o documento inteiro',
    colors: {
      label: 'Cores',
      none: 'Cor padrão',
      callout: 'Cor do destaque',
      gray: 'Cinza',
      red: 'Vermelho',
      orange: 'Laranja',
      yellow: 'Amarelo',
      green: 'Verde',
      blue: 'Azul',
      purple: 'Roxo',
      pink: 'Rosa',
    },
    files: {
      attach: 'Anexar um arquivo',
      download: 'Baixar {{name}}',
    },
    workChip: {
      insert: 'Tarefa',
      hint: 'Busque uma tarefa por chave ou título. Também é vinculada ao digitar uma chave como VAM-123 seguida de um espaço.',
      unavailable: 'Esta tarefa não existe ou você não tem acesso',
    },
    presence: {
      label: 'Pessoas neste documento agora',
      editing: '{{name}} está editando',
      viewing: '{{name}} está lendo',
    },
    collab: { rejected: 'Uma alteração não pôde ser salva, então o documento recarregou com a versão mais recente de todos.' },
    backlinks: { title: 'Documentos', mentionedIn: 'Mencionado em' },
    projectFolder: { title: 'Documentação', choose: 'Escolher a pasta de documentação', hint: 'A pasta onde este projeto guarda seus documentos. Quem pode lê-la a vê aqui.', folder: 'Pasta', none: 'Ainda não há pasta de documentação.', noneOption: 'Sem pasta' },
    person: {
      tasks: 'Tarefas',
      documents: 'Documentos',
      recent: 'Atividade recente',
      noActivity: 'Sem tarefas nem documentos recentes.',
    },
    tableMenu: {
      menu: 'Tabela',
      rowAbove: 'Inserir linha acima',
      rowBelow: 'Inserir linha abaixo',
      columnLeft: 'Inserir coluna à esquerda',
      columnRight: 'Inserir coluna à direita',
      headerRow: 'Ativar ou remover linha de cabeçalho',
      deleteRow: 'Excluir linha',
      deleteColumn: 'Excluir coluna',
      deleteTable: 'Excluir tabela',
    },
    blocks: {
      plainText: 'Texto simples',
      diagramView: 'Diagrama ou código',
      code: 'Código',
      add: 'Adicionar um bloco',
      basic: 'Básicos',
      richBlocks: 'Blocos',
      mediaAndLinks: 'Arquivos e links',
      text: 'Texto',
      insert: 'Inserir',
      callout: 'Destaque',
      toggle: 'Recolhível',
      toc: 'Sumário',
      tocEmpty: 'Adicione títulos para montar o sumário.',
      video: 'Vídeo',
      videoHint: 'Cole um link do YouTube, Loom, Vimeo ou Google Drive.',
      videoUrl: 'Link do vídeo',
      insertVideo: 'Inserir vídeo',
      embedUnsupported: 'Só é possível incorporar vídeos do YouTube, Loom, Vimeo e Google Drive.',
      mermaid: 'Diagrama Mermaid',
      diagram: 'Diagrama',
      mermaidError: 'O diagrama tem um erro de sintaxe.',
      language: 'Linguagem do código',
      showCode: 'Ver código',
      hideCode: 'Ocultar código',
    },
    properties: {
      title: 'Propriedades',
      manage: 'Gerenciar propriedades',
    },
    import: {
      action: 'Importar',
      menu: 'Importar documentos',
      title: 'Importar em {{folder}}',
      intro: 'Traga documentos do Word, Google Docs, Markdown ou Notion para esta pasta. Cada arquivo vira um documento; as imagens e o arquivo original ficam guardados com ele.',
      formats: 'Aceitos: Word (.docx), páginas web (.html), Markdown (.md), tabelas CSV (.csv) e exportações do Notion (.zip).',
      notionHelp: 'Notion: em Configurações, escolha Exportar, selecione “Markdown & CSV” com subpáginas e envie o .zip. As pastas viram pastas, as páginas viram documentos com suas subpáginas, os bancos de dados viram tabelas e as imagens vêm para cá.',
      googleHelp: 'Google Docs: escolha Google Drive abaixo para importar direto do seu Drive, ou use Arquivo → Fazer download → Microsoft Word (.docx) ou Página da web (.html compactado) e envie esse arquivo.',
      drive: {
        button: 'Google Drive',
        hint: 'Escolha documentos do Google Docs, ou arquivos Word, HTML, Markdown e CSV guardados no Drive. O Google pede uma única vez que você permita ao Vammo Work abrir só os arquivos escolhidos.',
        notConfigured: 'A importação direta do Google Drive não está configurada. Peça a um administrador para configurar o acesso ao Google Drive.',
        opening: 'Abrindo o Google Drive…',
        waiting: 'Aguardando o Google…',
        pickerTitle: 'Escolha os arquivos para importar',
        source: 'Google Drive',
        remove: 'Remover {{name}}',
        errors: {
          unavailable: 'Não foi possível acessar o Google Drive. Verifique a conexão e tente de novo.',
          popupBlocked: 'O navegador bloqueou a janela de login do Google. Permita pop-ups para este site e tente de novo.',
          popupClosed: 'A janela de login do Google foi fechada antes de conceder o acesso.',
          denied: 'O acesso ao Google Drive não foi concedido.',
          auth: 'O login do Google expirou ou foi revogado. Escolha os arquivos do Google Drive de novo.',
          forbidden: 'O Google Drive recusou o acesso a este arquivo. Peça ao dono que compartilhe com você ou que permita o download.',
          notFound: 'O arquivo não foi encontrado no Google Drive. Pode ter sido excluído ou movido.',
          quota: 'O Google Drive está limitando as solicitações agora. Aguarde um minuto e tente de novo.',
          tooLarge: 'O arquivo é grande demais para exportar do Google Drive.',
          unsupported: 'Este tipo de arquivo do Google Drive não pode ser importado.',
          network: 'O download do Google Drive falhou. Verifique a conexão e tente de novo.',
          timeout: 'O Google não respondeu a tempo. Tente de novo.',
          closed: 'A sessão do Google Drive foi encerrada. Escolha os arquivos de novo.',
        },
      },
      privateNote: 'Os documentos importados começam como rascunhos privados que só você vê, para você revisar antes que a pasta os veja.',
      choose: 'Escolher arquivos',
      fileInput: 'Arquivos para importar',
      noFiles: 'Nenhum arquivo escolhido ainda.',
      start: 'Importar',
      stop: 'Parar',
      progress: '{{done}} de {{total}} prontos',
      progressLabel: 'Progresso da importação',
      status: {
        pending: 'Aguardando',
        working: 'Importando',
        done: 'Importado',
        failed: 'Falhou',
        skipped: 'Não importado',
      },
      summary_one: '{{count}} documento importado em {{folder}}.',
      summary_other: '{{count}} documentos importados em {{folder}}.',
      stopped: 'A importação foi interrompida. O que já foi importado continua.',
      lockHint: 'Os documentos importados são rascunhos privados que só você vê. Revise cada um e depois desbloqueie pelo menu Mais ações para compartilhar com a pasta.',
      created: 'Documentos importados',
      foldersCreated: 'Pastas criadas',
      skippedTitle: 'Não importado',
      failedTitle: 'Com erro',
      copy: 'Copiar relatório',
      copied: 'Relatório copiado',
      footer: 'Importado em {{date}} de',
      notes_one: '{{count}} nota de importação',
      notes_other: '{{count}} notas de importação',
      issues: {
        equation: 'Equações mantidas como código LaTeX',
        footnote: 'Notas de rodapé mantidas como texto simples',
        html: 'HTML que o editor não suporta; o texto foi mantido: {{detail}}',
        remoteImage: 'Imagem de outro site mantida como link, sem copiar: {{detail}}',
        unsafeLink: 'Link removido porque o endereço não é permitido: {{detail}}',
        brokenLink: 'Link removido porque o destino não faz parte da importação: {{detail}}',
        missingFile: 'Arquivo não encontrado na importação: {{detail}}',
        embed: 'Conteúdo incorporado não suportado, mantido como link: {{detail}}',
        converterWarning: 'Nota da conversão do Word: {{detail}}',
        comments: 'Os comentários não são importados',
        rowsCapped: 'Tabela cortada nas primeiras linhas ({{detail}})',
        fileTooLarge: 'Arquivo com mais de 25 MB não enviado: {{detail}}',
        uploadFailed: 'Não foi possível enviar o arquivo: {{detail}}',
        notInline: 'Formato de imagem que os documentos não mostram, anexado como arquivo: {{detail}}',
        tooDeep: 'Subiu um nível: as subpáginas aninham até 8 níveis',
        plainText: 'Não foi possível manter o formato, então o texto foi importado como parágrafos simples',
        originalTooLarge: 'Original com mais de 25 MB não anexado: {{detail}}',
        unsupportedBlock: 'Bloco do Notion não suportado, omitido: {{detail}}',
        columns: 'As colunas ficaram uma abaixo da outra',
        database: 'Banco de dados do Notion importado como tabela estática: {{detail}}',
        pageNotImported: 'Link para uma página não importada, mantido como link para o Notion: {{detail}}',
        truncated: 'Página cortada após os primeiros {{detail}} blocos',
        cellShortened: 'Valores do banco de dados encurtados para caber: {{detail}}',
        cellDropped: 'Valores do banco de dados deixados de fora porque não cabiam na propriedade: {{detail}}',
      },
      tabs: { files: 'Arquivos', notion: 'Notion' },
      notion: {
        intro: 'Importe páginas direto do seu espaço do Notion. Na própria tela do Notion você escolhe quais páginas o Vammo Work pode ler; só essas podem ser importadas.',
        connect: 'Conectar o Notion',
        connectHint: 'Você vai ao Notion escolher as páginas que compartilha e volta para cá.',
        connectedTo: 'Conectado a {{workspace}}',
        sharePages: 'Compartilhar outras páginas',
        search: 'Buscar páginas do Notion',
        searchPlaceholder: 'Buscar pelo título',
        empty: 'Ainda não há páginas compartilhadas com o Vammo Work. Use “Compartilhar outras páginas” para escolhê-las no Notion.',
        noMatches: 'Nenhuma página compartilhada corresponde.',
        loadMore: 'Carregar mais',
        database: 'Banco de dados',
        pageList: 'Páginas do Notion compartilhadas',
        selected_one: '{{count}} página selecionada',
        selected_other: '{{count}} páginas selecionadas',
        subpagesNote: 'As subpáginas vêm junto. Bancos de dados viram tabelas de até 500 linhas. Arquivos e imagens do Notion são copiados para cá.',
        start: 'Importar do Notion',
        queued: 'Aguardando o início da importação…',
        running: 'Importando do Notion: {{done}} de {{total}} páginas',
        failedRun: 'A importação parou: {{error}}',
        alreadyRunning: 'Você já tem uma importação do Notion em andamento. Espere terminar ou interrompa e depois inicie outra.',
        reconnectNeeded: 'O Notion não aceita mais sua conexão. Conecte o Notion de novo.',
        openInNotion: 'Abrir no Notion',
        connected: 'Notion conectado',
        denied: 'O acesso ao Notion não foi concedido',
        stateError: 'Não foi possível confirmar a conexão com o Notion. Tente de novo.',
        connectFailed: 'Não foi possível conectar o Notion. Tente de novo.',
        skipReasons: {
          limit: 'mais de 200 páginas em uma importação',
          notShared: 'não compartilhada com o Vammo Work',
          duplicate: 'já importada nesta execução',
          cancelled: 'a importação foi interrompida antes',
          timeLimit: 'a importação atingiu antes o tempo máximo; importe de novo',
          interrupted: 'a importação foi interrompida antes; importe de novo',
        },
      },
      skipReasons: {
        unsafePath: 'caminho inseguro ou repetido no zip',
        unreferenced: 'nenhuma página usa',
        unsupportedType: 'tipo de arquivo não suportado',
        tooLarge: 'grande demais',
        emptyFile: 'arquivo vazio',
        cancelled: 'a importação foi interrompida antes',
      },
      errors: {
        zipTooLarge: 'O zip tem mais de {{limit}} MB descompactado.',
        zipTooManyFiles: 'O zip tem mais de {{limit}} arquivos.',
        zipUnreadable: 'O arquivo não é um zip legível.',
        nothingToImport: 'O zip não tem páginas Markdown, HTML nem CSV.',
        cancelled: 'Interrompido antes de salvar o conteúdo; o documento está vazio.',
      },
    },
    subpages: {
      title: 'Subpáginas',
      new: 'Nova subpágina',
      empty: 'Ainda não há subpáginas.',
    },
    readers: {
      title: 'Quem viu',
      hint: 'Pessoas que abriram este documento e quando abriram pela última vez.',
      empty: 'Ninguém mais abriu ainda.',
      views_one: '{{count}} visualização',
      views_other: '{{count}} visualizações',
    },
    diff: {
      title: 'Comparar versões',
      content: 'Conteúdo',
      changes: 'Alterações',
      against: 'Alterações desde a revisão {{n}}',
      first: 'Primeira revisão: tudo é novo',
      noChanges: 'Esta revisão não altera o texto.',
    },
    translation: {
      label: 'Idioma',
      original: 'Original',
      locales: { en: 'EN', 'pt-BR': 'PT', es: 'ES' },
      reasons: {
        DISABLED: 'Este ambiente não tem tradutor automático.',
        DAILY_LIMIT: 'O limite diário de IA foi atingido; os blocos ainda não traduzidos mostram o original.',
        RATE_LIMIT: 'Muitos pedidos de tradução; os blocos novos são traduzidos em um minuto.',
        INVALID: 'Não foi possível mostrar a tradução.',
      },
      pending: 'Tradução automática em andamento: {{done}} de {{total}} blocos prontos.',
      ready: 'Tradução automática, somente leitura. O original continua sendo a fonte.',
      unavailable: 'A tradução automática não está disponível; mostrando o original.',
    },
    draft: {
      start: 'Editar sem publicar',
      banner: 'Alterações não publicadas',
      bannerHint: 'Só você vê estas alterações até publicá-las.',
      stale: 'O documento mudou depois que você começou este rascunho; publicar substitui essas alterações.',
      publish: 'Publicar',
      discard: 'Descartar alterações',
      published: 'Alterações publicadas',
      staleConfirm: 'O documento mudou depois que você começou este rascunho. Publicar mesmo assim e substituir essas alterações?',
      discardConfirm: 'Descartar suas alterações não publicadas?',
    },
    table: {
      byPerson: 'De {{name}}',
      clearPerson: 'Ver os documentos de todos',
      title: 'Tabela de documentos',
      search: 'Buscar por título',
      folder: 'Pasta',
      allFolders: 'Todas as pastas',
      addFilter: 'Adicionar filtro',
      removeFilter: 'Remover filtro',
      property: 'Propriedade',
      operator: 'Condição',
      ops: { eq: 'é', contains: 'contém', empty: 'está vazio', set: 'tem valor' },
      choose: 'Escolher…',
      yes: 'Sim',
      no: 'Não',
      document: 'Documento',
      updated: 'Atualizado',
      empty: 'Nenhum documento corresponde a estes filtros.',
    },
    toolbar: {
      label: 'Formatação',
      underline: 'Sublinhado',
      textColor: 'Cor do texto',
      bold: 'Negrito',
      italic: 'Itálico',
      strike: 'Tachado',
      code: 'Código em linha',
      heading1: 'Título 1',
      heading2: 'Título 2',
      heading3: 'Título 3',
      bulletList: 'Lista com marcadores',
      orderedList: 'Lista numerada',
      taskList: 'Lista de tarefas',
      quote: 'Citação',
      codeBlock: 'Bloco de código',
      link: 'Link',
      linkPrompt: 'Endereço do link (https://, mailto: ou um /caminho)',
      linkInvalid: 'Esse endereço não é permitido',
      table: 'Inserir tabela',
      divider: 'Divisor',
      undo: 'Desfazer',
      redo: 'Refazer',
    },
    public: {
      folderName: 'Público externo',
      folderHint: 'Qualquer pessoa com o link público de um documento pode lê-lo sem entrar. Documentos novos aqui começam como rascunhos privados: desbloqueie um para publicá-lo.',
      badge: 'Público',
      badgeHint: 'Qualquer pessoa com o link público pode ler este documento',
      button: 'Link público',
      title: 'Link público',
      description: 'Qualquer pessoa com este link pode ler o documento sem entrar, inclusive fora da Vammo. Comentários, histórico e autores continuam privados.',
      disabled: 'Os links públicos estão desativados neste ambiente.',
      notPublicLocked: 'Este documento é um rascunho privado, então não é público. Desbloqueie-o para publicá-lo.',
      notPublicArchived: 'Este documento está arquivado, então o link público não funciona.',
      notPublicOutside: 'Só documentos da pasta Público externo têm link público.',
      copy: 'Copiar link',
      copied: 'Link público copiado',
      open: 'Abrir a página pública',
      rotate: 'Trocar link',
      rotateConfirm: 'O link atual deixará de funcionar na hora.',
      rotated: 'Link trocado; o anterior não funciona mais',
      passwordOn: 'Leitores precisam de uma senha',
      passwordOff: 'Sem senha: o link basta',
      passwordNew: 'Senha',
      passwordChange: 'Trocar senha',
      passwordSet: 'Exigir senha',
      passwordRemove: 'Remover senha',
      passwordHint: 'Pelo menos 8 caracteres. Compartilhe separada do link; ela não pode ser mostrada de novo.',
      passwordSaved: 'Senha salva',
      passwordRemoved: 'Senha removida',
      views: 'Visualizações nos últimos 30 dias: {{count}}',
      viewsTotal: 'no total: {{count}}',
      confirmTitle: 'Tornar público?',
      confirmBody: 'Qualquer pessoa com o link poderá lê-lo sem entrar, inclusive pessoas de fora da Vammo. Comentários, histórico e autores continuam privados.',
      published: 'Publicado: qualquer pessoa com o link público pode lê-lo',
      confirmAction: 'Publicar',
      restrictedNotAllowed: 'A empresa inteira vê as pastas de Público externo, porque tudo o que está nelas pode ser publicado. Para limitar quem vê esta pasta, tire-a de Público externo primeiro.',
      restrictedMoveRefused: 'Uma pasta que limita quem a vê (ou que tem uma subpasta assim) não pode ir para Público externo. Primeiro deixe-a visível para a empresa inteira.',
    },
  },
  publicPage: {
    loading: 'Carregando o documento',
    notFound: 'Este link não está disponível',
    notFoundHint: 'O documento não existe ou não é mais público. Peça um novo link a quem o compartilhou.',
    passwordTitle: 'Este documento é protegido',
    passwordHint: 'Digite a senha que você recebeu com o link.',
    password: 'Senha',
    open: 'Abrir',
    wrongPassword: 'Essa senha não está correta',
    tooMany: 'Tentativas demais. Aguarde alguns minutos e tente de novo.',
    updated: 'Atualizado {{date}}',
    internalDocument: 'documento interno',
    databaseNotShown: 'Banco de dados não exibido publicamente',
    contents: 'Conteúdo',
    download: 'baixar',
    sharedFrom: 'Compartilhado pelo Vammo Work',
    error: 'Não foi possível carregar o documento.',
    retry: 'Tentar de novo',
  },
  visibility: {
    title: 'Visibilidade',
    grants: 'Pessoas, times e grupos',
    addGrant: 'Adicionar acesso',
    searchPrincipal: 'Busque pessoas, times ou grupos',
    inherit: 'Restrições dos projetos pais sempre se aplicam.',
    changed: 'Visibilidade atualizada',
  },
  settings: {
    title: 'Configurações',
    profile: 'Perfil',
    displayName: 'Nome de exibição',
    language: 'Idioma',
    timezone: 'Fuso horário',
    notifications: 'Notificações',
    identities: 'Contas vinculadas',
    noIdentities: 'Nenhuma conta vinculada.',
    roles: 'Acesso',
    basic: 'Acesso básico',
    notion: {
      title: 'Notion',
      description: 'Importe páginas do seu espaço do Notion para documentos. Você escolhe no Notion quais páginas o Vammo Work pode ler.',
      notConnected: 'O Notion não está conectado.',
      connect: 'Conectar o Notion',
      connectedTo: 'Conectado a {{workspace}} desde {{date}}',
      disconnect: 'Desconectar',
      confirmDisconnect: 'Desconectar o Notion?',
      disconnected: 'Notion desconectado',
      revokeHint: 'Desconectar apaga o acesso guardado aqui. Para remover o Vammo Work também do Notion, abra Configurações → Conexões no Notion.',
    },
    github: {
      addLabel: 'Adicionar uma conta do GitHub',
      hint: 'Seu usuário do GitHub, por exemplo uma conta pessoal com a qual você às vezes faz commits. Contas que fazem commits com seu e-mail da Vammo são vinculadas automaticamente.',
      placeholder: 'usuário',
      add: 'Adicionar',
      added: 'Conta do GitHub adicionada',
      remove: 'Remover',
      removed: 'Conta do GitHub removida',
      confirmRemove: 'Remover esta conta?',
      method: { self: 'Adicionada por você', email: 'Verificada pelo e-mail do commit', admin: 'Vinculada por um administrador', other: 'Vinculada' },
      errors: {
        notFound: 'Nenhuma conta do GitHub tem esse usuário.',
        notUser: 'Só é possível adicionar contas pessoais do GitHub, não organizações nem bots.',
        taken: 'Esta conta do GitHub já está vinculada a outra pessoa. Peça a um administrador.',
        tooMany: 'Você já tem o número máximo de contas do GitHub.',
        unavailable: 'Não foi possível contatar o GitHub. Tente novamente em instantes.',
      },
    },
  },
  admin: {
    title: 'Administração',
    users: 'Usuários e papéis',
    groups: 'Grupos de visibilidade',
    integrations: 'Integrações',
    exceptions: 'Exceções',
    imports: 'Importação do Jira',
    audit: 'Registro de auditoria',
    operations: 'Operações',
    roles: 'Papéis',
    capabilities: 'Capacidades',
    roleHints: { SUPERADMIN: 'Controle total. Lê todos os registros, inclusive pastas restritas, rascunhos privados e relatórios sensíveis. Só um Superadmin nomeia Superadmins.', ADMIN: 'Gerencia pessoas, equipes, grupos, conectores, operações e importações. Lê só o que o próprio acesso permite.', DEVELOPER: 'Trabalho de engenharia e relatórios técnicos.', PRODUCT: 'Triagem e trabalho de produto.' },
    status: 'Status',
    suspend: 'Suspender',
    reactivate: 'Reativar',
    lastLogin: 'Último login',
    agents: { column: 'Agentes de IA', none: 'Nenhum', lastSeen: 'Última conexão {{when}}', via: { PLUGIN: 'Plugin', MCP: 'Só MCP', UNKNOWN: 'Não confirmado' }, viaHint: { PLUGIN: 'Plugin {{version}} instalado', MCP: 'Servidor MCP configurado sem o plugin', UNKNOWN: 'Usado antes de o tracker registrar como se conecta; confirmado na próxima conexão' }, filter: 'Conexão de agentes', filters: { ALL: 'Todos', PLUGIN: 'Plugin instalado', MCP: 'Só MCP', NONE: 'Sem agente' } },
    changeAccess: 'Alterar acesso',
    reasonRequired: 'Um motivo é registrado no log de auditoria.',
    reason: { title: 'Registrar um motivo', label: 'Motivo', hint: 'O motivo fica no registro de auditoria.', confirm: 'Confirmar' },
    integ: { lastSuccess: 'Último sucesso', lastAttempt: 'Última tentativa', lastError: 'Último erro', circuit: 'Circuito aberto até', cursor: 'Cursor', probe: 'Testar', reconcile: 'Reconciliar', reconcileQueued: 'Reconciliação enfileirada', liveVerified: 'Verificado ao vivo', health: { HEALTHY: 'Saudável', DEGRADED: 'Degradado', FAILING: 'Falhando', DISABLED: 'Desativado', UNVERIFIED: 'Não verificado' }, modes: { live: 'Ao vivo', fixture: 'Fixture', disabled: 'Desativado' } },
    deliveries: { title: 'Entregas de notificações', hint: 'Um envio incerto pode já ter chegado à pessoa. Verifique a evidência do provedor antes de tentar de novo.', filter: 'Status da entrega', filters: { DELIVERY_UNKNOWN: 'Incertas ou com falha', BOUNCED: 'Devolvidas ou suprimidas', SENT: 'Enviadas', ALL: 'Todas' }, empty: 'Nenhuma entrega precisa de atenção.', attempts: '{{count}} tentativa(s)', retry: 'Tentar novamente', retryTitle: 'Tentar esta entrega novamente', retryHint: 'A mensagem pode ser enviada de novo. O motivo fica no registro de auditoria.', retried: 'Nova tentativa na fila' },
    services: { title: 'Serviços e ambientes', hint: 'Aprove quais repositórios constroem cada serviço e quais ambientes são produção. A cobertura usa apenas mapeamentos aprovados.', empty: 'Nenhum serviço descoberto ainda.', repositories: 'Repositórios', environments: 'Ambientes', buildPath: 'Caminho de build (opcional)', buildPathFor: 'Caminho de build de {{name}}', classificationFor: 'Classificação de {{name}}', noRepositories: 'Nenhum repositório mapeado.', approve: 'Aprovar mapeamento', approved: 'Mapeamento aprovado', classes: { PRODUCTION: 'Produção', STAGING: 'Staging', DEVELOPMENT: 'Desenvolvimento', PREVIEW: 'Preview', OTHER: 'Outro' } },
    identities: { action: 'Contas vinculadas', title: 'Contas vinculadas', hint: 'Vincule uma conta do GitHub ou Jira apenas quando tiver confirmado que pertence a esta pessoa. Os vínculos são auditados.', none: 'Nenhuma conta vinculada.', add: 'Vincular uma conta', provider: 'Provedor', search: 'Buscar por usuário ou ID', candidates: 'Contas que podem ser vinculadas', historical: 'Histórico do Jira', unmapped: 'Vista {{count}} vez(es)', noCandidates: 'Nenhuma conta sem vínculo encontrada.', link: 'Vincular conta', linked: 'Conta vinculada', unlink: 'Desvincular' },
    exc: { empty: 'Nenhuma exceção aberta.', resolve: 'Resolver', ignore: 'Ignorar', open: 'Abrir', occurrences: '{{count}} ocorrência(s)', filterKind: 'Tipo', all: 'Todos os tipos', kinds: { UNMATCHED_WORK: 'Trabalho sem associação', UNCERTAIN_ASSOCIATION: 'Associação incerta', UNMAPPED_IDENTITY: 'Identidade sem mapeamento', UNMAPPED_REPOSITORY: 'Repositório sem mapeamento', UNMAPPED_SERVICE: 'Serviço sem mapeamento', CONNECTOR_FAILURE: 'Falha de conector', DUPLICATE_CORRECTION: 'Correção de duplicado', WEBHOOK_INTEGRITY: 'Integridade de webhook', DEPLOYMENT_ORDERING: 'Ordem de deploys', DELIVERY_UNKNOWN: 'Entrega incerta', IMPORT_EXCEPTION: 'Exceção de importação', ACL_QUARANTINE: 'Quarentena de acesso', SCOPE_REVIEW: 'Revisão de escopo', COMPLETION_BLOCKED: 'Conclusão bloqueada' } },
    ops: { noAlerts: 'Sem alertas ativos', outbox: 'Outbox pendente', worker: 'Worker', healthy: 'Saudável', stale: 'Sem heartbeat', aiTokens: 'Tokens de IA hoje', queue: 'Fila', queued: 'Na fila', active: 'Ativos', oldest: 'Espera mais antiga', dead: 'Dead letters', replay: 'Reprocessar', deadEmpty: 'Nenhum job em dead letter.' },
    imp: { mode: 'Modo', projects: 'Chaves de projeto (separadas por vírgula; vazio usa os projetos aprovados)', start: 'Iniciar', queued: 'Importação enfileirada', resume: 'Retomar', cancel: 'Cancelar', empty: 'Nenhuma execução de importação ainda.', exceptions: '{{count}} exceção(ões)', mapping: 'Mapeamentos', mappingHelp: 'Execute a descoberta primeiro. Aprove cada projeto antes de importar amostra, completo ou delta. Níveis de segurança sem mapeamento ficam em quarentena para administradores.', save: 'Salvar mapeamentos', saved: 'Mapeamentos salvos', approved: 'Aprovado', targetProject: 'Projeto de destino', targetTeam: 'Time de triagem/responsável', none: 'Nenhum', requestTypes: 'Tipos importados como solicitações', statusMap: 'Mapeamento de status', securityLevels: 'Níveis de segurança', securityGroup: 'Visível para o grupo', quarantine: 'Quarentena (só administradores)', reconciliation: 'Reconciliação', modes: { DISCOVERY: 'Descoberta', DRY_RUN: 'Simulação', SAMPLE: 'Amostra', FULL: 'Importação completa', DELTA: 'Delta', RECONCILE: 'Reconciliar' }, statuses: { QUEUED: 'Na fila', RUNNING: 'Em execução', PAUSED: 'Pausada', SUCCEEDED: 'Concluída', FAILED: 'Falhou', CANCELED: 'Cancelada' } },
    slackDest: { title: 'Destinos de progresso no Slack', help: 'Canais internos aprovados que recebem o progresso de um projeto ou time. Itens restritos só publicam um link, a menos que o destino seja aprovado para conteúdo restrito e todos os membros sejam membros plenos do workspace.', scope: 'Escopo', project: 'Projeto', team: 'Time', workspace: 'ID do workspace', channel: 'ID do canal', restricted: 'Aprovado para conteúdo restrito', milestones: 'Marcos', add: 'Salvar destino', remove: 'Remover', empty: 'Nenhum destino configurado.', saved: 'Destino salvo', milestoneNames: { REQUEST_RECEIVED: 'Solicitação recebida', REQUEST_ACCEPTED: 'Solicitação aceita', REQUEST_REJECTED: 'Solicitação rejeitada', REQUEST_RESOLVED: 'Solicitação resolvida', REQUEST_NEEDS_ATTENTION: 'Precisa de atenção', WORK_CREATED: 'Tarefa criada', WORK_STARTED: 'Tarefa em andamento', WORK_IN_REVIEW: 'Tarefa em revisão', WORK_BLOCKED: 'Tarefa bloqueada', WORK_INTEGRATED: 'Tarefa integrada', WORK_DEPLOYED: 'Implantada em produção', WORK_DELIVERED: 'Tarefa concluída', WORK_CANCELED: 'Tarefa cancelada' } },
  },
  reports: {
    notes: {
      sourceNotConnected: '{{source}} não está conectado; seus valores são desconhecidos, não zero.',
      sourceNotLive: 'Os dados de {{source}} vêm do modo {{mode}}, não são evidência real.',
      sourceNeverSynced: '{{source}} ainda não sincronizou com sucesso.',
      duplicatesIncluded: '{{count}} destas solicitações estão marcadas como duplicatas.',
      reconsideredExcluded: '{{count}} decisões reconsideradas no período ficam fora da taxa.',
      generationsAcrossRequests: '{{generations}} gerações de atendimento em {{requests}} solicitações distintas.',
      mixedBases: 'Bases de conclusão misturadas ({{bases}}); escolha uma para comparar coisas equivalentes.',
      partialCohorts: 'A janela de acompanhamento vai de cada primeira conclusão até agora; coortes recentes são parciais.',
      unattributedBugs_one: '{{count}} bug visível criado no período, independentemente dos filtros, está sem causa informada; já fechados: {{closed}}.',
      unattributedBugs_other: '{{count}} bugs visíveis criados no período, independentemente dos filtros, estão sem causa informada; já fechados: {{closed}}.',
      noDeliveryCause_one: '{{count}} bug visível criado no período, independentemente dos filtros, não tem causa de entrega: {{breakdown}}.',
      noDeliveryCause_other: '{{count}} bugs visíveis criados no período, independentemente dos filtros, não têm causa de entrega: {{breakdown}}.',
      openWindow_one: '{{count}} item implantado há menos de {{days}} dias ainda pode receber defeitos neste período.',
      openWindow_other: '{{count}} itens implantados há menos de {{days}} dias ainda podem receber defeitos neste período.',
      caughtBeforeRelease_one: '{{count}} bug vinculado foi encontrado antes da implantação da origem e fica de fora.',
      caughtBeforeRelease_other: '{{count}} bugs vinculados foram encontrados antes da implantação da origem e ficam de fora.',
      outsideWindow_one: '{{count}} bug vinculado foi encontrado mais de {{days}} dias após a implantação da origem e fica de fora.',
      outsideWindow_other: '{{count}} bugs vinculados foram encontrados mais de {{days}} dias após a implantação da origem e ficam de fora.',
      originNotDeployed_one: '{{count}} bug vinculado indica trabalho sem conclusão “{{basis}}” e fica de fora.',
      originNotDeployed_other: '{{count}} bugs vinculados indicam trabalho sem conclusão “{{basis}}” e ficam de fora.',
      currentState: 'Estado atual no momento da consulta; estados passados não são reconstruídos para esta métrica.',
      rolledBack: '{{count}} implantações revertidas aparecem separadas.',
      noIncidentSource: 'Nenhuma fonte de incidentes está conectada; o tempo de recuperação fica indisponível e nunca é inferido das implantações.',
      activityNotProductivity: 'Contribuições são indicadores de atividade, não uma medida de produtividade.',
      prAttribution: 'A autoria é indicada por pull request, não por linha. Exclusões de arquivos gerados só valem com dados completos de arquivos.',
      captureDenominator: 'Denominador: pull requests observados em repositórios vinculados a projetos; trabalho fora da plataforma não tem denominador.',
      providerErrors: '{{count}} chamadas ao provedor falharam.',
      weightCoverage: '{{scored}} pontuados, {{unscored}} sem pontuação (informação insuficiente, pendentes ou com falha). Não elegíveis: {{historical}} históricos, {{restricted}} restritos, {{platform}} registros da plataforma, {{parent}} pais.',
      mixedQuestionVersions: 'Pontuações de {{count}} versões de perguntas estão misturadas neste período.',
      weightingNotLive: 'A ponderação de trabalho está em modo {{mode}}; os pontos não são julgamentos reais do modelo.',
    },
    filters: { any: 'Qualquer', source: 'Origem', mine: 'Só minhas contribuições', mineCauses: 'Só trabalho atribuído a mim', person: 'Pessoa', causeAssignee: 'Responsável pela causa' },
    defects: {
      open: 'Ver os defeitos por trás deste número',
      title: 'Defeitos escapados · {{group}}',
      unitBug: 'Cada linha é um bug, com todas as causas que o contam aqui.',
      unitPair: 'Cada linha é um bug e uma causa: um bug com várias causas neste grupo aparece uma vez por causa, como na contagem.',
      bug: 'Bug',
      created: 'Criado em',
      cause: 'Causado por',
      teamProject: 'Time · projeto',
      days: 'Após a implantação',
      daysValue_one: '{{count}} dia',
      daysValue_other: '{{count}} dias',
      showing_one: 'Mostrando {{shown}} de {{total}} defeito.',
      showing_other: 'Mostrando {{shown}} de {{total}} defeitos.',
      empty: 'Nenhum defeito corresponde mais a este número.',
      emptyHint: 'Os dados mudaram desde a contagem; atualize o relatório.',
    },
    chartLabel: 'Gráfico de {{metric}} por grupo',
    title: 'Relatórios',
    subtitle: 'Métricas calculadas a partir de fatos registrados, com o seu acesso aplicado. Dados desconhecidos nunca aparecem como zero.',
    metric: 'Métrica',
    period: 'Período',
    groupBy: 'Agrupar por',
    basis: 'Base de conclusão',
    anyBasis: 'Todas as bases',
    firstOnly: 'Só a primeira conclusão',
    run: 'Executar',
    export: 'Exportar CSV',
    exporting: 'Preparando exportação…',
    download: 'Baixar CSV',
    total: 'Total',
    count: 'Quantidade',
    unavailable: 'Indisponível',
    median: 'Mediana',
    p85: 'Percentil 85',
    coverage: 'Cobertura',
    overlapping: 'Os grupos se sobrepõem: uma tarefa pode aparecer em vários grupos, então as linhas não somam o total.',
    empty: 'Sem dados neste período.',
    tierLabel: 'Nível',
    formula: 'Fórmula v{{version}}',
    watermark: 'Dados de {{time}}',
    definition: 'Definição',
    last7: 'Últimos 7 dias',
    last30: 'Últimos 30 dias',
    last90: 'Últimos 90 dias',
    thisYear: 'Este ano',
    from: 'De',
    to: 'Até',
    group: 'Grupo',
    value: 'Valor',
    ratio: '{{num}} de {{den}}',
    tiers: { GENERAL: 'Geral', TECHNICAL: 'Técnico', SENSITIVE: 'Sensível' },
    coverageStatus: { COMPLETE: 'Completa', PARTIAL: 'Parcial', UNKNOWN: 'Desconhecida' },
    groups: { none: 'Sem agrupamento', team: 'Time', project: 'Projeto', type: 'Tipo', priority: 'Prioridade', week: 'Semana', month: 'Mês', repository: 'Repositório', service: 'Serviço', person: 'Pessoa', outcome: 'Resultado', source: 'Origem' },
    metrics: {
      requests_created: { name: 'Solicitações criadas', help: 'Solicitações enviadas pela data de envio.' },
      request_first_response: { name: 'Tempo até a primeira resposta', help: 'Do envio até a primeira decisão humana de triagem.' },
      request_acceptance_rate: { name: 'Taxa de aceitação', help: 'Primeiras aceitações sobre aceitas mais rejeitadas.' },
      requests_fulfilled: { name: 'Solicitações resolvidas', help: 'Solicitações distintas resolvidas no período.' },
      request_lead_time: { name: 'Lead time da solicitação', help: 'Do envio até a resolução, por resolução.' },
      work_completed: { name: 'Trabalho concluído', help: 'Itens de trabalho distintos concluídos no período.' },
      work_cycle_time: { name: 'Tempo de ciclo', help: 'Do início à conclusão de cada episódio.' },
      work_in_progress: { name: 'Trabalho em andamento', help: 'Itens em andamento, revisão ou integrados agora.' },
      blocked_time: { name: 'Tempo bloqueado', help: 'União dos intervalos bloqueados por item no período.' },
      review_wait: { name: 'Espera por revisão', help: 'Do pedido de revisão até a decisão.' },
      integration_to_production: { name: 'Da integração à produção', help: 'Da integração até a entrega verificada em produção.' },
      deployment_frequency: { name: 'Frequência de deploy', help: 'Deploys bem-sucedidos em produção.' },
      deployment_failure_rate: { name: 'Taxa de falha de deploy', help: 'Falhos sobre bem-sucedidos mais falhos em produção.' },
      reopen_rate: { name: 'Taxa de reabertura', help: 'Trabalho concluído que depois foi reaberto.' },
      escaped_defects: { name: 'Defeitos escapados', help: 'Bugs encontrados dentro de uma janela fixa após a implantação do trabalho que os causou.' },
      recovery_time: { name: 'Tempo de recuperação', help: 'Requer evidência de incidentes; indisponível sem uma fonte.' },
      contribution_activity: { name: 'Contribuições', help: 'Contribuições observadas de implementação, revisão e outras.' },
      code_additions: { name: 'Linhas adicionadas', help: 'Adições reportadas pelo provedor em PRs mesclados.' },
      code_deletions: { name: 'Linhas removidas', help: 'Remoções reportadas pelo provedor em PRs mesclados.' },
      capture_coverage: { name: 'Cobertura de captura', help: 'PRs observados vinculados a trabalho confirmado.' },
      requester_confirmation: { name: 'Confirmação do solicitante', help: 'Confirmado, persiste ou sem resposta por resolução.' },
      integrated_ai_usage: { name: 'Uso de IA', help: 'Tokens reportados pelo provedor para tradução, intake e ponderação de trabalho.' },
      weighted_work_completed: { name: 'Trabalho concluído ponderado', help: 'Pontos dos itens folha concluídos, ponderados pelo TypeSafe Jev (1, 2, 3, 5, 8 ou 13 cada).' },
    },
  },
  attachments: {
    title: 'Arquivos',
    add: 'Anexar arquivos',
    empty: 'Nenhum arquivo anexado ainda.',
    uploading: 'Enviando {{name}}…',
    scanning: 'Verificando malware',
    rejected: 'Rejeitado',
    download: 'Baixar',
    remove: 'Remover arquivo',
    removed: 'Arquivo removido',
    tooLarge: '{{name}} tem mais de {{max}} MiB.',
    tooMany: 'Você pode anexar no máximo {{max}} arquivos por vez.',
    uploaded: '{{count}} arquivo(s) enviado(s); ficam disponíveis após a verificação de malware.',
    pendingNote: 'Os arquivos ficam em quarentena até a verificação terminar.',
    video: 'Vídeo',
    view: 'Ver {{name}}',
    viewer: 'Visualizador de arquivos',
    viewerHint: 'Use as setas para passar de um arquivo a outro e Esc para fechar.',
    counter: '{{index}} de {{total}}',
    previous: 'Arquivo anterior',
    next: 'Próximo arquivo',
    actualSize: 'Tamanho real',
    fitToScreen: 'Ajustar à tela',
    openInNewTab: 'Abrir em uma nova aba',
    loadFailed: 'Este arquivo não pode ser exibido aqui. Baixe-o para abri-lo no seu dispositivo.',
  },
  savedViews: {
    title: 'Visões',
    mine: 'Minhas visões',
    sharedWithEveryone: 'Visões compartilhadas',
    shared: 'Compartilhada',
    empty: 'Nenhuma visão salva ainda.',
    saveCurrent: 'Salvar filtros atuais…',
    name: 'Nome da visão',
    shareLabel: 'Compartilhar com todos (só os filtros; cada pessoa continua vendo apenas o que pode acessar)',
    hint: 'Uma visão salva guarda os filtros, nunca os resultados.',
    saved: 'Visão salva',
    deleted: 'Visão excluída',
    delete: 'Excluir visão',
  },
  slack: {
    modalTitle: 'Criar solicitação Vammo',
    reviewTitle: 'Revisar solicitação',
    next: 'Próximo',
    submit: 'Enviar',
    cancel: 'Cancelar',
    close: 'Fechar',
    privacyNote: 'Só você vê este formulário. A solicitação é privada até você enviá-la.',
    fields: { title: 'Título curto', problem: 'O que está acontecendo?', expected: 'O que deveria acontecer?', impact: 'Quem é afetado e quanto? (deixe vazio se não souber)' },
    impactUnknown: 'Desconhecido por enquanto',
    duplicates: 'Solicitações possivelmente relacionadas',
    submitted: 'Solicitação *{{key}}* enviada. Acompanhe aqui: {{url}}',
    dmHelp: 'Escreva numa mensagem o que você precisa e eu transformo num rascunho de solicitação Vammo que você revisa antes de enviar. Você também pode usar /vammo-work ou o atalho "Create Vammo request" em qualquer mensagem.',
    dmDraftReady: 'Preparei um rascunho de solicitação: *{{title}}*. Revise, complete e envie:',
    dmReview: 'Revisar e enviar',
    linkPrompt: 'Para criar solicitações pelo Slack, vincule sua conta do Slack à sua conta Vammo (link privado, válido por 10 minutos): {{url}}',
    notLinked: 'Sua conta do Slack ainda não está vinculada. Execute /vammo-work de novo.',
    expired: 'Este rascunho não está mais disponível. Comece de novo com /vammo-work.',
    required: 'Obrigatório',
    unavailable: 'Não foi possível abrir o formulário. Tente de novo ou use o app web.',
    progress: '*{{key}}* {{title}} — {{status}}\n{{url}}',
    progressLinkOnly: 'Um item acompanhado foi atualizado. Abra no Vammo Work: {{url}}',
    linkTitle: 'Vincular conta do Slack',
    linkBody: 'Vincular o usuário do Slack {{handle}} à sua conta Vammo? As solicitações criadas pelo Slack serão registradas em seu nome.',
    linkConfirm: 'Vincular conta',
    linkDone: 'Sua conta do Slack foi vinculada. Pode fechar esta aba e executar /vammo-work de novo.',
    linkInvalid: 'Este link expirou ou já foi usado. Execute /vammo-work no Slack para obter um novo.',
  },
  notifications: {
    preferences: {
      title: 'Configurações de notificação',
      event: 'Evento',
      email: 'E-mail',
      browser: 'Navegador',
      immediate: 'Na hora',
      digest: 'Resumo diário',
      muted: 'Desativado',
      on: 'Ativado',
      off: 'Desativado',
    },
    events: {
      REQUEST_RECEIVED: 'Recebemos sua solicitação',
      REQUEST_NEEDS_INFORMATION: 'Precisamos de mais informações',
      REQUEST_ACCEPTED: 'Sua solicitação foi aceita',
      REQUEST_REJECTED: 'Sua solicitação não foi aceita',
      REQUEST_WORK_STARTED: 'O trabalho na sua solicitação começou',
      REQUEST_RESOLVED: 'Sua solicitação foi resolvida',
      REQUEST_NEEDS_ATTENTION: 'Uma solicitação precisa de atenção',
      WORK_ASSIGNED: 'Trabalho atribuído a você',
      WORK_BLOCKED: 'Algo que você segue está bloqueado',
      COMMENT_ADDED: 'Novo comentário em algo que você segue',
      MENTIONED: 'Você foi mencionado',
      WORK_DUE_SOON: 'Um trabalho seu vence em breve',
      WORK_OVERDUE: 'Um trabalho seu está atrasado',
      WORK_STALE: 'Um trabalho seu está sem atividade',
      WORK_AUTOMATION: 'Uma regra automática enviou um aviso para você',
    },
    browser: {
      title: 'Notificações do navegador',
      enable: 'Ativar neste navegador',
      disable: 'Desativar neste navegador',
      test: 'Enviar um teste',
      enabled: 'As notificações do navegador estão ativadas',
      disabled: 'As notificações estão desativadas neste navegador',
      testSent: 'Notificação de teste enviada',
      testNone: 'Nenhum navegador aceitou o teste. Desative e ative as notificações de novo.',
      blockedHelp: 'As notificações estão bloqueadas para este site. Permita-as nas configurações do site no navegador (o ícone ao lado do endereço).',
      devices: 'Navegadores que recebem notificações',
      unknownDevice: 'Navegador',
      forget: 'Esquecer',
      state: {
        unsupported: 'Este navegador não consegue mostrar notificações. No iPhone e iPad, adicione o tracker à Tela de Início primeiro.',
        blocked: 'As notificações estão bloqueadas para este site. Permita-as nas configurações do site no navegador e recarregue a página.',
        off: 'Receba atribuições, menções e novidades do que você segue, mesmo com o tracker fechado.',
        on: 'Este navegador mostra suas notificações.',
      },
    },
  },
  push: {
    testTitle: 'As notificações estão ativadas',
    testBody: 'Este navegador mostrará suas notificações do Vammo Work.',
  },
  email: {
    greeting: 'Olá {{name}},',
    open: 'Abrir no Vammo Work',
    footer: 'Você recebe isto porque participa deste registro. Altere as notificações no seu perfil.',
    actionConfirm: 'Sim, está resolvido',
    actionPersists: 'Não, ainda acontece',
    actionComment: 'Deixar um comentário',
    confirmHint: 'Diga ao time se funcionou para você: abra a solicitação e escolha "Sim, está resolvido" ou "Não, ainda acontece". Abrir este e-mail ou link nunca registra uma resposta por si só.',
    digestSubject: 'Seu resumo do Vammo Work',
    layout: {
      kindRequest: 'Solicitação',
      kindWork: 'Trabalho',
      kindDocument: 'Documento',
      openRequest: 'Abrir a solicitação',
      openWork: 'Abrir o trabalho',
      openDocument: 'Abrir o documento',
      openMyWork: 'Abrir Meu trabalho',
      manageNotifications: 'Gerenciar suas notificações',
      actionNeeded: 'Requer ação',
      update: 'Novidade',
      digestHeadline: 'Seu resumo do dia',
      digestIntro: 'Veja o que aconteceu nos registros que você segue ({{count}}).',
    },
    events: {
      REQUEST_RECEIVED: { subject: '[{{key}}] Recebemos sua solicitação', headline: 'Recebemos sua solicitação', body: 'Sua solicitação "{{title}}" foi recebida e aguarda triagem.' },
      REQUEST_NEEDS_INFORMATION: { subject: '[{{key}}] Precisamos de mais informações', headline: 'O time precisa de mais informações', body: 'O time precisa de mais informações sobre "{{title}}".' },
      REQUEST_ACCEPTED: { subject: '[{{key}}] Sua solicitação foi aceita', headline: 'Sua solicitação foi aceita', body: 'Sua solicitação "{{title}}" foi aceita. Aceitar não é uma data de entrega; você será avisado quando o trabalho começar.' },
      REQUEST_REJECTED: { subject: '[{{key}}] Sua solicitação não foi aceita', headline: 'Sua solicitação não foi aceita', body: 'Sua solicitação "{{title}}" não foi aceita. Abra-a para ler o motivo.' },
      REQUEST_WORK_STARTED: { subject: '[{{key}}] O trabalho começou', headline: 'O trabalho na sua solicitação começou', body: 'O trabalho em "{{title}}" começou.' },
      REQUEST_RESOLVED: { subject: '[{{key}}] Resolvida — confirme, por favor', headline: 'Sua solicitação foi resolvida', body: 'O time resolveu "{{title}}".' },
      REQUEST_NEEDS_ATTENTION: { subject: '[{{key}}] Requer atenção', headline: 'Uma solicitação precisa da sua atenção', body: 'O solicitante informa que "{{title}}" ainda acontece, ou a entrega necessária foi perdida.' },
      WORK_ASSIGNED: { subject: '[{{key}}] Atribuído a você', headline: 'Novo trabalho atribuído a você', body: '"{{title}}" foi atribuído a você.' },
      WORK_BLOCKED: { subject: '[{{key}}] Bloqueado', headline: 'Algo que você segue está bloqueado', body: '"{{title}}" está bloqueado.' },
      WORK_DONE: { subject: '[{{key}}] Concluído', headline: 'Algo que você segue foi concluído', body: '"{{title}}" foi concluído.' },
      COMMENT_ADDED: { subject: '[{{key}}] Novo comentário', headline: 'Novo comentário', body: 'Há um novo comentário em "{{title}}".' },
      MENTIONED: { subject: '[{{key}}] Você foi mencionado', headline: 'Você foi mencionado', body: 'Você foi mencionado em "{{title}}".' },
      WORK_DUE_SOON: { subject: '[{{key}}] Vence em breve', headline: 'O trabalho vence em breve', body: '"{{title}}" vence em breve.' },
      WORK_OVERDUE: { subject: '[{{key}}] Atrasado', headline: 'O trabalho está atrasado', body: '"{{title}}" passou da data de entrega.' },
      WORK_STALE: { subject: '[{{key}}] Sem atividade recente', headline: 'Trabalho sem atividade recente', body: '"{{title}}" não muda há algum tempo. Atualize ou feche se não for mais necessário.' },
      WORK_AUTOMATION: { subject: '[{{key}}] Aviso automático', headline: 'Uma regra automática enviou um aviso para você', body: 'Uma regra automática enviou um aviso sobre "{{title}}". Abra para ver a mensagem.' },
    },
  },
  tutorial: {
    title: 'Tutorial',
    subtitle: 'Conecte seu assistente de IA, peça o que você precisa, planeje o trabalho com sua equipe e deixe o trabalho de código ser registrado sozinho.',
    toc: 'Nesta página',
    copy: 'Copiar',
    copied: 'Copiado',
    copyFailed: 'Não foi possível copiar; selecione o texto e copie manualmente.',
    footer: 'Tudo o que você ou seu assistente fazem aqui roda com as suas próprias permissões.',
    intro: {
      title: 'Para que serve o tracker',
      lead: 'O Vammo Work é onde vive todo o trabalho da Vammo: o que as pessoas pedem, as tarefas que as equipes executam e o código que as entrega. A ideia é simples: **seu trabalho se registra sozinho**. Você, ou seu assistente de IA, faz o trabalho; o tracker registra, vincula à tarefa certa e acompanha até estar rodando em produção. Todos veem o que está acontecendo sem precisar perguntar nem atualizar tickets à mão.',
      requests: { title: 'Solicitações', body: 'Qualquer pessoa descreve uma necessidade ou um problema (chaves `REQ-`) e acompanha até confirmar que foi resolvido.' },
      work: { title: 'Trabalho', body: 'As equipes transformam necessidades em tarefas (chaves `VAM-`) e acompanham em listas e quadros, por equipe, projeto ou pessoa.' },
      agents: { title: 'Seu assistente mantém tudo em dia', body: 'Com o plugin da Vammo, o Claude ou o Codex abrem a tarefa, passam para em andamento, registram os marcos e vinculam branches, commits e pull requests enquanto você programa.' },
      delivery: { title: 'A entrega é verificada', body: 'O trabalho está concluído quando o tracker vê o código implantado em produção, não quando alguém diz que está.' },
      start: 'O primeiro passo: **conecte seu assistente de IA** logo abaixo. Leva poucos minutos e é o que torna o acompanhamento automático.',
    },
    connect: {
      title: 'Conecte seu assistente de IA',
      intro: 'O tracker é um servidor MCP. Depois de conectado, seu assistente pode abrir solicitações, criar e atualizar trabalho e registrar o que faz, sempre como você e com as suas permissões. Você entra com sua conta Vammo; não há nenhuma chave de API para copiar.',
      serverUrl: 'URL do servidor',
      pluginTitle: 'O que é instalado?',
      plugin: 'O **plugin** do Codex e do Claude Code adiciona a conexão MCP e uma habilidade que orienta o assistente a registrar o trabalho. O Claude Code também recebe um lembrete no início da sessão. A configuração do ChatGPT abaixo cria um plugin a partir do servidor MCP, com ferramentas e instruções. O trabalho é registrado quando o assistente chama essas ferramentas; a instalação não registra todas as conversas.',
      claudeDesktop: {
        name: 'Claude (web e desktop)',
        summary: 'O chat do Claude no claude.ai e no app para Windows e macOS. Com a sua conta da empresa o plugin já vem instalado; você só conecta uma vez.',
        s1: 'No Claude, abra **Customize → Plugins** e confira se o **Vammo Work Tracker** está lá. Ele vem instalado com a sua conta da empresa.',
        s2: 'Abra o plugin, vá até a aba **Connectors** e escolha **Connect**. O login da Vammo abre no navegador: entre com sua conta Google da Vammo e aprove o acesso solicitado.',
        s3: 'Configure as permissões de ferramentas do conector: **Sempre permitir** para as ferramentas que leem e registram trabalho (`get_…`, `search_…`, `ensure_work_item`, `start_work_session`, `link_code`, `record_progress`, `finish_work_session`, `add_comment`…). Deixe **Precisa de aprovação** para `write_operation`, que pode fazer tudo o que você pode fazer na web, inclusive apagar.',
        s4: 'Em um chat novo, abra o menu de ferramentas (**+**) e confira se o **Vammo Work Tracker** está ativado. A skill do plugin precisa de **execução de código**: se o Claude não a seguir, ative a execução de código em **Settings → Capabilities**.',
        s5: 'Usa uma conta pessoal do Claude? Lá o plugin não aparece: abra **Settings → Connectors → Add custom connector**, dê o nome `Vammo Work Tracker`, cole a URL do servidor, conecte e configure as permissões como no passo 3:',
        s6: 'Opcional: cole estas instruções em um projeto do Claude para ele sempre trabalhar com o tracker:',
        instructions: 'Use the Vammo Work Tracker connector for requests and work. Call get_context first. To file a request, call prepare_request with what I describe, show me the draft and missing fields, and only call submit_request after I confirm. When a request I filed is resolved, ask me whether it is fixed and record confirm_request. Never invent facts, priorities or deployment status.',
      },
      claudeCode: {
        name: 'Claude Code (terminal)',
        summary: 'O Claude no seu terminal, na sua IDE ou na aba Code do app desktop. Com a sua conta da empresa, o Claude Code instala o plugin sozinho ao iniciar; ele traz o servidor, a skill de acompanhamento e um lembrete, para que o trabalho de código seja registrado automaticamente em todos os seus repositórios.',
        s1: 'Usa uma conta pessoal do Claude? Instale o plugin uma vez (com a conta da empresa não é necessário):',
        s2: 'Reinicie o Claude Code, execute `/mcp`, selecione `plugin:vammo-work-tracker:vammo` e escolha **Authenticate**. Entre com sua conta Google da Vammo no navegador. Isso é feito uma vez por computador.',
        s3: 'Na primeira vez que o Claude usa cada ferramenta da Vammo, ele pede permissão. Responda **Yes, and don’t ask again** para as ferramentas que leem e registram trabalho; para `write_operation`, que pode fazer tudo o que você pode fazer na web, deixe que continue perguntando.',
        s4: 'Se você configurou o tracker manualmente antes, execute `claude mcp remove vammo` e apague `~/.claude/skills/vammo-work-tracking/`, para não duplicar ferramentas.',
        s5: 'Mantenha o plugin atualizado. Com a conta da empresa ele se atualiza sozinho; com uma conta pessoal, execute isto e reinicie o Claude Code:',
      },
      chatgptDesktop: {
        name: 'ChatGPT (web)',
        summary: 'Comece em chatgpt.com, no espaço de trabalho em que você usará o tracker. Se Vammo Work Tracker já aparecer em Plugins, instale e conecte sua conta.',
        s1: 'Abra **Plugins**, escolha **+** e depois **Add custom MCP server** (adicionar servidor MCP personalizado).',
        s2: 'Use o nome **Vammo Work Tracker**, cole a URL e escolha **OAuth**. Se pedir um método de registro, escolha **Dynamic client registration (DCR)**. Não é necessário fornecer uma API key nem um segredo de cliente:',
        s3: 'Revise o aviso de acesso, escolha **Create as a plugin** e depois **Install**. Quando solicitar a conexão, entre com sua conta Google da Vammo e aprove o acesso.',
        s4: 'Em uma nova conversa, digite **@** e selecione **Vammo Work Tracker**. Peça para chamar `get_context` e confira se retorna seu nome.',
        note: 'Os menus e a disponibilidade dependem do espaço de trabalho e da versão. Se servidores MCP personalizados não estiverem disponíveis, peça ao administrador para habilitá-los. Configure e verifique primeiro na web. As permissões para executar ferramentas dependem do ChatGPT e são diferentes do login.',
      },
      codex: {
        name: 'Codex (CLI e IDE)',
        summary: 'Use uma versão atual do Codex CLI no mesmo computador e perfil de usuário do seu IDE. Instalar e conectar sua conta Vammo são etapas separadas. Estes comandos foram verificados com o Codex CLI 0.162.0.',
        s1: 'Instale o plugin uma vez. Ele adiciona o servidor e a habilidade de acompanhamento, sem exigir acesso a um repositório privado do GitHub:',
        s2: 'Conecte sua conta Vammo. No navegador, entre com seu Google da Vammo e aprove o acesso. Aguarde a confirmação de sucesso no terminal:',
        s3: 'Abra uma nova sessão do Codex. Se usar a extensão do IDE, reinicie-a para carregar o plugin e a conexão.',
        s4: 'Confira se `vammo` está habilitado e usa OAuth; depois faça a verificação abaixo. Aparecer na lista não comprova que o login funciona:',
        maintenance: 'Atualizações e instalações manuais anteriores',
        update: 'Quando houver uma atualização do plugin, atualize o marketplace, confira a versão instalada com `codex plugin list` e reinicie o Codex:',
        migration: 'Se as ferramentas aparecerem duplicadas por uma instalação manual anterior, faça uma cópia da configuração. Quando o plugin funcionar, remova somente a entrada manual antiga `[mcp_servers.vammo]` e a habilidade duplicada que você havia copiado. Mantenha os arquivos do plugin.',
      },
      verifyTitle: 'Confira a conexão',
      verify: 'Peça: “Use Vammo Work Tracker para chamar get_context e informar meu nome e permissões”. Confira se a chamada à ferramenta funciona com sua conta. Ter o servidor configurado ou o plugin instalado não basta para verificar a conexão.',
      sessionTitle: 'Manter a sessão conectada',
      session: 'O cliente renova o acesso em segundo plano. O tracker permite 90 dias entre renovações, então o uso habitual mantém a conexão mesmo ao fechar o navegador. Entre novamente em um dispositivo ou perfil novo, se as credenciais forem apagadas, após 90 dias sem renovação ou se o acesso for revogado. Contas suspensas não podem se conectar. Aprovar uma ferramenta é diferente de fazer login.',
      troubleTitle: 'Se a conexão falhar',
      trouble: 'Se faltarem ferramentas, reinicie o Codex ou atualize o plugin no ChatGPT e tente get_context novamente. Para um erro de autenticação, execute `codex mcp login vammo` ou reconecte o plugin do ChatGPT uma vez. Pedir login a cada poucos minutos é uma falha: informe ao administrador do tracker a versão do cliente, o horário e o erro. Não envie tokens nem URLs de retorno do login.',
      adminNote: 'Seu espaço de trabalho precisa permitir conexões MCP a esta URL. Conectar o ChatGPT não faz login em uma instalação separada do Codex.',
    },
    request: {
      title: 'Peça uma nova funcionalidade',
      intro: 'Qualquer pessoa pode pedir uma funcionalidade ou relatar um problema. Você não precisa saber como construir: descreva o que precisa e por quê. Cada solicitação recebe uma chave `REQ-`.',
      web: { title: 'Pela web', body: 'Escolha **Nova solicitação** ou pressione `R`. A aba **Guiado** faz perguntas em linguagem simples; a aba **Formulário** permite preencher os campos diretamente. Rascunhos ficam privados até você enviar.' },
      assistant: { title: 'Pelo Claude ou ChatGPT', body: 'Diga, por exemplo: “Abra uma solicitação: os pilotos querem ver o histórico de trocas no app.” O assistente prepara um rascunho, mostra o que falta e só envia depois que você confirmar.' },
      slack: { title: 'Pelo Slack', body: 'Execute `/vammo-work` ou use o atalho **Create Vammo request** em qualquer mensagem. Na primeira vez, o Slack envia um link privado para conectar sua conta.' },
      tipsTitle: 'O que faz uma boa solicitação',
      t1: 'O que acontece hoje e o que deveria acontecer.',
      t2: 'Quem é afetado e o quanto isso importa; “ainda não sei” é uma resposta válida.',
      t3: 'Prints, links ou exemplos como anexos.',
      after: 'A triagem aceita a solicitação e a vincula a um trabalho, e você é avisado conforme ela avança. Quando for entregue, você será perguntado se o problema foi resolvido.',
    },
    team: {
      title: 'Crie tarefas para sua equipe',
      intro: 'Itens de trabalho (chaves `VAM-`) são as tarefas que uma equipe executa. Uma solicitação descreve uma necessidade; um item de trabalho descreve o que será feito a respeito.',
      s1: 'Escolha **Novo item de trabalho** ou pressione `C`.',
      s2: 'Escreva um título curto e escolha o tipo: funcionalidade, bug, manutenção, pesquisa etc.',
      s3: 'Em **Responsável**, escolha a equipe (ou **Pessoal** para o seu próprio trabalho). Se quiser, defina uma pessoa, um projeto e uma prioridade.',
      s4: 'Adicione critérios de aceitação: os resultados observáveis que indicam que a tarefa está pronta.',
      s5: 'Para atender uma solicitação, abra-a e escolha **Novo item de trabalho** ali, assim quem pediu acompanha o andamento automaticamente.',
      s6: 'Acompanhe em **Trabalho** como lista ou quadro, filtrando por equipe, projeto ou responsável.',
      assistantTitle: 'Ou peça ao seu assistente',
      assistant: '“Crie uma tarefa para a equipe de Plataforma adicionar um filtro ao histórico de trocas, prioridade alta.” O assistente diz o que vai criar e pede confirmação antes.',
    },
    notifications: {
      title: 'Ative as notificações',
      intro: 'Saiba quando suas solicitações avançam, quando um trabalho é atribuído a você ou quando alguém menciona você, sem deixar o tracker aberto. Tudo também aparece na lista de notificações dentro do tracker.',
      open: 'Configurar notificações',
      s1: 'Abra **Configurações → Notificações**, ou escolha o sino no canto superior direito.',
      s2: 'Em **Notificações do navegador**, escolha **Ativar neste navegador** e aceite quando o navegador pedir permissão.',
      s3: 'Escolha **Enviar um teste** para conferir. Repita em cada computador ou celular onde quiser receber; o mesmo cartão lista seus navegadores para você esquecer os antigos.',
      s4: 'Em **Configurações de notificação**, escolha para cada evento: e-mail **Na hora**, **Resumo diário** ou **Desativado**, e navegador **Ativado** ou **Desativado**.',
      browser: { title: 'Navegador', body: 'Avisos neste dispositivo, mesmo com a aba do tracker fechada. São ativados por navegador e por dispositivo.' },
      email: { title: 'E-mail', body: 'Ativado por padrão para suas solicitações, atribuições e menções. **Resumo diário** junta as novidades do dia em um único e-mail.' },
      slack: { title: 'Slack', body: 'Solicitações abertas pelo Slack recebem o andamento na mesma thread. Para publicar também as novidades de um projeto em um canal, veja **Use o tracker pelo Slack** mais abaixo.' },
      troubleTitle: 'Se as notificações não chegarem',
      blocked: 'Se o navegador bloqueou, permita as notificações nas configurações do site (o ícone ao lado do endereço) e recarregue a página.',
      iphone: 'No iPhone ou iPad, primeiro adicione o tracker à Tela de Início (**Compartilhar → Adicionar à Tela de Início**) e ative pelo ícone.',
      missing: 'Se você não vê **Notificações do navegador** em Configurações, elas ainda não estão habilitadas neste ambiente; o e-mail e a lista dentro do app continuam funcionando.',
    },
    slack: {
      title: 'Use o tracker pelo Slack',
      intro: 'Acompanhe as novidades de um projeto em um canal do Slack e peça ao @leonardo para criar e consultar trabalho sem sair da conversa.',
      channelTitle: 'Publique as novidades de um projeto em um canal',
      c1: 'No Slack, abra o canal e convide o app. Sem isso ele não consegue publicar ali, e os canais privados nem aparecem na lista:',
      c2: 'No tracker, abra o projeto, escolha **Configurações** e vá até **Novidades no Slack**. Escolha o canal na lista de canais que o app consegue ver.',
      c3: 'Escolha quais novidades publicar: tarefas criadas, em andamento, em revisão, bloqueadas, integradas, **implantadas em produção**, concluídas ou canceladas, e os marcos das solicitações. Um canal de releases, por exemplo, pode acompanhar só **Implantada em produção**.',
      c4: 'Escolha **Salvar canal do Slack**. Para parar de publicar, escolha **Nenhum canal** e salve. Os responsáveis pelo projeto e os administradores podem alterar. Cada tarefa tem uma mensagem no canal, e as próximas novidades vão nessa thread.',
      leonardoTitle: 'Peça ao @leonardo',
      leonardo: 'O **@leonardo** é o agente da Vammo no Slack e está conectado ao tracker. Mencione-o em um canal ou em uma thread e ele trabalha como você, com as suas permissões. Por exemplo:',
      e1: 'Abrir uma solicitação com o que você descreve: “@leonardo abra uma solicitação: os motoristas não veem o histórico de trocas.”',
      e2: 'Criar uma tarefa para uma equipe: “@leonardo crie uma tarefa para Platform adicionar um filtro ao histórico de trocas, prioridade alta.”',
      e3: 'Ler uma conversa inteira e transformá-la em trabalho: “@leonardo leia esta thread e crie as tarefas que saem dela para Fleet Operations.”',
      e4: 'Consultar: “@leonardo qual é o status do VAM-42?” ou “o que ainda está aberto em Rider App?”',
      e5: 'Atribuir e mencionar as pessoas da conversa: ele reconhece os membros do Slack pelo e-mail da empresa.',
      noteTitle: 'Bom saber',
      note: 'O que o @leonardo faz aparece no histórico em seu nome (via Clawbot), e ele nunca tem permissões de administrador. O comando `/vammo-work` e o atalho **Create Vammo request** continuam funcionando.',
    },
    tracking: {
      title: 'O trabalho de código é registrado sozinho',
      intro: 'Você não precisa atualizar tickets à mão. Quando você programa com um assistente conectado ou abre pull requests, o tracker registra o trabalho e o vincula à tarefa certa.',
      f1: { title: 'Você começa uma tarefa', body: 'Com o plugin instalado, o assistente registra seu objetivo, repositório e branch. Ele reutiliza a tarefa que você indicar (por exemplo `VAM-42`) ou a que já está vinculada à sua branch ou sessão, e só cria uma nova quando nada corresponde. A tarefa passa sozinha para **Em andamento**. As tarefas que um agente cria por conta própria mostram um ícone de robô, e o filtro **Criadas por agentes** as lista para a equipe revisar.' },
      f2: { title: 'Os marcos são registrados', body: 'Andamento, verificações que ele realmente executou, bloqueios e pull requests são adicionados à tarefa conforme a sessão avança. Um pequeno arquivo dentro de `.git/` guarda o vínculo entre sessões e nunca é commitado.' },
      f3: { title: 'O GitHub confirma', body: 'Um pull request cujo título, branch ou descrição menciona uma chave como `VAM-42`, ou cuja branch corresponde a uma sessão de agente, é vinculado automaticamente. Associe o repositório a um projeto; além dos webhooks, o tracker reconcilia a cada 15 minutos.' },
      f4: { title: 'A entrega é verificada', body: 'Quando todos os pull requests vinculados são mergeados, o trabalho de produção passa para integrado. Ele chega sozinho a **Concluído** quando o tracker vê uma implantação em produção que contém o seu código; ninguém precisa declarar quais serviços ele afeta. Um PR mergeado ou uma sessão encerrada não bastam.' },
      keyTipTitle: 'Dica: coloque a chave na branch',
      keyTip: 'Uma branch como `feat/VAM-42-swap-history`, ou `VAM-42` no título do pull request, vincula o trabalho com certeza, mesmo sem assistente.',
      ambiguousTitle: 'Quando a correspondência é incerta',
      ambiguous: 'Títulos parecidos são apenas sugestões. Se várias tarefas puderem corresponder, o assistente mostra as candidatas e pergunta. Se o trabalho precisar continuar enquanto isso, ele cria um item provisório que aparece na caixa de exceções para confirmar ou mesclar; nada se perde.',
    },
  },
  table: {
    total_one: '{{count}} item',
    total_other: '{{count}} itens',
    showing_one: '{{count}} carregado',
    showing_other: '{{count}} carregados',
    sortBy: 'Ordenar por {{column}}',
    ascending: 'Ordem crescente',
    descending: 'Ordem decrescente',
    people: 'Pessoas',
    peopleRole: 'Papel',
    clearPeople: 'Limpar pessoas',
    selected: 'Selecionado',
    activeFilters: 'Filtros ativos',
    removeFilter: 'Remover filtro',
    noOwner: 'Ninguém',
    createdBy: 'Criado por',
    empty: 'Vazio',
    due: {
      overdue: 'Atrasados',
      soon: 'Próximos 7 dias',
      none: 'Sem prazo',
      set: 'Com prazo',
    },
    editMode: 'Editar na tabela',
    editModeOn: 'Edição na tabela: as mudanças são salvas na hora. Abra um item pelo título.',
    saved: 'Salvo',
    phaseMoveHint: 'Mover para…',
    searchPeople: 'Buscar pessoas',
  },
  fields: {
    documentsTitle: 'Propriedades de documentos',
    documentsHint: 'Propriedades que qualquer documento pode ter, como status, responsável ou tipo. Elas também filtram a tabela de documentos.',
    title: 'Campos personalizados',
    projectTitle: 'Campos do projeto',
    hint: 'Campos tipados nos itens de trabalho. Arquivar um campo o oculta; os valores são mantidos.',
    manage: 'Gerenciar campos',
    section: 'Campos',
    name: 'Nome',
    type: 'Tipo',
    add: 'Adicionar campo',
    created: 'Campo criado',
    empty: 'Ainda não há campos.',
    archived: 'Arquivado',
    archive: 'Arquivar campo',
    restore: 'Restaurar campo',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    optionName: 'Opção',
    newOption: 'Nova opção',
    addOption: 'Adicionar',
    removeOption: 'Remover {{name}}',
    none: 'Nenhum campo se aplica a este item.',
    filterTitle: 'Campo',
    global: 'Todo o trabalho',
    types: {
      TEXT: 'Texto',
      NUMBER: 'Número',
      BOOLEAN: 'Sim / não',
      DATE: 'Data',
      SINGLE_SELECT: 'Escolha única',
      MULTI_SELECT: 'Múltipla escolha',
    },
  },
  calendar: {
    title: 'Calendário',
    previous: 'Mês anterior',
    next: 'Próximo mês',
    today: 'Hoje',
    count_one: '{{count}} item vence nesta visão',
    count_other: '{{count}} itens vencem nesta visão',
    hint: 'Arraste um item para mudar o prazo',
    more_one: '+{{count}} mais',
    more_other: '+{{count}} mais',
  },
  similar: {
    title: 'Trabalho parecido que já existe',
    aiTitle: 'Possíveis duplicados',
    aiNone: 'A IA não encontrou duplicados entre os registros parecidos.',
    check: 'Verificar com IA',
    checkRequests: 'Procurar duplicados com IA',
    noTextMatches: 'Nenhuma solicitação parecida pelo texto.',
    byAi: 'IA',
    fixture: 'Modo de teste',
    confidence: {
      HIGH: 'A mesma coisa',
      MEDIUM: 'Provavelmente o mesmo',
      LOW: 'Texto parecido',
    },
  },
  triageAssist: {
    title: 'Sugestão de triagem com IA',
    hint: 'Propõe prioridade, equipe, projeto, tipo e etiquetas a partir da solicitação. Nada muda até você aplicar.',
    suggest: 'Sugerir',
    again: 'Sugerir de novo',
    apply: 'Aplicar',
    ask: 'Perguntar a quem pediu',
    projectHint: 'Mova pelo campo de projeto para revisar quem vai ver.',
    createWork: 'Criar trabalho com isto',
  },
  automations: {
    title: 'Automações',
    subtitle: 'Regras que agem sobre o trabalho quando algo acontece: atribuir, priorizar, etiquetar, definir datas ou avisar.',
    new: 'Nova regra',
    edit: 'Editar regra',
    dialogHint: 'As regras agem como o sistema, no máximo uma vez por mudança, e as próprias mudanças nunca disparam regras.',
    scope: 'Escopo',
    allScopes: 'Todas as regras que posso ver',
    showArchived: 'Mostrar arquivadas',
    empty: 'Ainda não há regras',
    emptyHint: 'Gestores de projeto criam regras para seus projetos; administradores, para todo o trabalho.',
    name: 'Nome',
    trigger: 'Gatilho',
    when: 'Quando',
    if: 'se',
    ifTitle: 'Se',
    then: 'Então',
    any: 'Qualquer',
    phases: 'Fase atual',
    fromPhases: 'Fase anterior',
    labelsAny: 'Tem alguma destas etiquetas',
    assignment: 'Atribuição',
    unassignedYes: 'sem responsável',
    unassignedNo: 'com alguém atribuído',
    action: 'Ação',
    addAction: 'Adicionar ação',
    removeAction: 'Remover ação',
    enabled: 'Ativa',
    saved: 'Regra salva',
    archive: 'Arquivar regra',
    restore: 'Restaurar regra',
    runs: 'Execuções recentes',
    runsTitle: 'Execuções de {{name}}',
    noRuns: 'Esta regra ainda não foi executada.',
    hiddenItem: 'Um item que você não pode ver',
    runCount_one: 'Executou {{count}} vez',
    runCount_other: 'Executou {{count}} vezes',
    lastRun: 'última',
    lastError: 'Último erro: {{error}}',
    runStatus: {
      APPLIED: 'Aplicada',
      FAILED: 'Falhou',
    },
    unassign: 'Ninguém (remover atribuição)',
    days: 'Dias',
    daysAfter: 'dias depois da mudança',
    onlyIfEmpty: 'Só se não tiver prazo',
    chooseField: 'Escolha um campo',
    message: 'Mensagem',
    messagePlaceholder: 'O que devem saber ou fazer?',
    addPerson: 'Adicionar pessoa',
    people_one: '{{count}} pessoa',
    people_other: '{{count}} pessoas',
    manage: 'Regras automáticas',
    byRule: 'Automação: {{name}}',
    triggers: {
      WORK_CREATED: 'um trabalho é criado',
      PHASE_CHANGED: 'a fase muda',
      PRIORITY_CHANGED: 'a prioridade muda',
      ASSIGNEE_CHANGED: 'o responsável muda',
      LABELS_CHANGED: 'as etiquetas mudam',
      DUE_DATE_CHANGED: 'o prazo muda',
      BLOCKED: 'o trabalho é bloqueado',
    },
    actions: {
      SET_PRIORITY: 'Definir prioridade',
      SET_ASSIGNEE: 'Atribuir a',
      ADD_LABELS: 'Adicionar etiquetas',
      REMOVE_LABELS: 'Remover etiquetas',
      SET_DUE_IN_DAYS: 'Definir prazo',
      SET_FIELD: 'Preencher um campo',
      NOTIFY: 'Avisar',
    },
    recipients: {
      ASSIGNEE: 'Responsável',
      OWNER: 'Dono',
      CREATOR: 'Quem criou',
      FOLLOWERS: 'Seguidores',
    },
    text: {
      SET_PRIORITY: 'definir prioridade {{value}}',
      SET_ASSIGNEE: 'atribuir a {{value}}',
      UNASSIGN: 'remover o responsável',
      ADD_LABELS: 'adicionar etiquetas {{value}}',
      REMOVE_LABELS: 'remover etiquetas {{value}}',
      SET_DUE_IN_DAYS_one: 'definir prazo {{count}} dia depois',
      SET_DUE_IN_DAYS_other: 'definir prazo {{count}} dias depois',
      SET_DUE_IF_EMPTY_one: 'se não tiver prazo, definir um {{count}} dia depois',
      SET_DUE_IF_EMPTY_other: 'se não tiver prazo, definir um {{count}} dias depois',
      SET_FIELD: 'definir {{field}} como',
      NOTIFY: 'avisar {{who}}: "{{message}}"',
    },
  },
  dashboards: {
    title: 'Painéis',
    subtitle: 'Suas próprias visões do trabalho: contagens, gráficos e listas sobre quaisquer filtros. Cada pessoa vê só o que pode acessar.',
    choose: 'Painel',
    new: 'Novo painel',
    name: 'Nome',
    withStarter: 'Começar com widgets úteis',
    empty: 'Ainda não há painéis',
    emptyHint: 'Crie um com o trabalho aberto, os atrasados, a carga por pessoa e a tendência semanal, e depois ajuste.',
    createStarter: 'Criar meu primeiro painel',
    sharedTag: 'compartilhado',
    share: 'Compartilhado com todos',
    edit: 'Editar',
    doneEditing: 'Pronto',
    more: 'Mais ações',
    rename: 'Renomear',
    copy: 'Fazer uma cópia',
    copyName: '{{name}} (cópia)',
    delete: 'Excluir painel',
    confirmDelete: 'Excluir "{{name}}"? Os widgets são removidos; o trabalho não muda.',
    noWidgets: 'Este painel ainda não tem widgets',
    addWidget: 'Adicionar widget',
    editWidget: 'Editar widget',
    removeWidget: 'Remover widget',
    moveBack: 'Mover para antes',
    moveForward: 'Mover para depois',
    saved: 'Painel salvo',
    widgetTitle: 'Título',
    kind: 'Widget',
    size: 'Tamanho',
    groupBy: 'Agrupar por',
    limit: 'Itens',
    weeks: 'Semanas',
    filters: 'Qual trabalho',
    filtersHint: 'Os mesmos filtros da lista de trabalho. "Quem estiver vendo" torna o widget pessoal para cada pessoa.',
    fromView: 'Copiar filtros de uma visão salva…',
    viewer: 'Quem estiver vendo',
    none: 'Nenhum',
    noData: 'Nada corresponde a estes filtros.',
    items: 'Itens',
    created: 'Criados',
    completed: 'Concluídos',
    seeAll: 'Ver todos os {{count}}',
    kinds: {
      COUNT: 'Número',
      BAR: 'Gráfico de barras',
      PIE: 'Gráfico de rosca',
      LIST: 'Lista',
      TREND: 'Tendência semanal',
    },
    sizes: {
      S: 'Pequeno',
      M: 'Meia largura',
      L: 'Largura total',
    },
    groups: {
      phase: 'Fase',
      priority: 'Prioridade',
      type: 'Tipo',
      assignee: 'Responsável',
      owner: 'Dono',
      project: 'Projeto',
      team: 'Equipe',
      label: 'Etiqueta',
    },
    sorts: {
      updatedAt: 'Atualizados recentemente',
      dueDate: 'Prazo',
      priority: 'Prioridade',
      createdAt: 'Mais novos',
    },
    starter: {
      name: 'Meu painel',
      open: 'Trabalho aberto',
      overdue: 'Atrasados',
      blocked: 'Bloqueados',
      byPhase: 'Trabalho por fase',
      byAssignee: 'Trabalho aberto por pessoa',
      trend: 'Criados e concluídos por semana',
      urgent: 'Urgente e prioridade alta',
    },
  },
  agentCreated: {
    label: 'Criado por um agente',
    origin: 'Origem',
    filter: 'Criadas por agentes',
    filterPeople: 'Criadas por pessoas',
    hint: 'Um agente de IA criou isto por conta própria para registrar o trabalho dele. O que você cria, ou pede a um agente que crie, não tem robô.',
    provisionalHint: 'Pode duplicar trabalho existente: confirme ou mescle.',
  },
  workWeight: {
    unit: 'pts',
    scored: 'Tamanho estimado automaticamente pelo TypeSafe Jev a partir do item e dos seus pull requests ao ser concluído (1, 2, 3, 5, 8 ou 13). Reabrir não soma pontos: o item mantém sua pontuação mais alta.',
    parent: 'Soma dos pontos dos seus subitens.',
    zero: '0 pontos: nenhum pull request, commit ou progresso estava vinculado na conclusão.',
    partial: 'Algumas conclusões ainda não foram pontuadas; os pontos atuais ainda podem subir.',
    pending: 'Ainda não pontuado; a pontuação roda cerca de 25 minutos após a conclusão.',
    unscored: 'Não foi possível pontuar: pouca informação ou a pontuação falhou.',
  },
  noEvidence: {
    badge: 'Sem evidência',
    hint: 'Uma pessoa fechou sem evidência de implantação nem de entregável',
    filter: 'Fechados sem evidência',
    dialogHint: 'O item passa a Concluído e fica marcado "Sem evidência". Explique por que está concluído, por exemplo onde foi implantado ou verificado.',
  },
  databases: {
    title: 'Título do banco de dados',
    untitled: 'Sem título',
    restricted: 'Banco de dados restrito',
    restrictedRow: 'Restrito',
    loadFailed: 'Não foi possível carregar o banco de dados.',
    menu: 'Ações do banco de dados',
    openFullPage: 'Abrir em página inteira',
    inDocument: 'Em {{name}}',
    archive: 'Arquivar banco de dados',
    archiveConfirm: 'Arquivar este banco de dados? Ele fica somente leitura onde for exibido, e seus editores podem restaurá-lo.',
    archivedNotice: 'Este banco de dados está arquivado e é somente leitura.',
    archivedBadge: 'Arquivado',
    archivedToast: 'Banco de dados arquivado',
    restore: 'Restaurar',
    restoredToast: 'Banco de dados restaurado',
    removeBlock: 'Remover deste documento',
    search: 'Buscar',
    noMatches: 'Nenhuma linha corresponde.',
    loadMore: 'Mostrar mais ({{shown}} de {{total}})',
    rowCount_one: '{{count}} linha',
    rowCount_other: '{{count}} linhas',
    export: {
      more: '… mais {{count}} linhas',
    },
    defaults: {
      title: 'Banco de dados sem título',
      name: 'Nome',
      status: 'Status',
      notStarted: 'Não iniciado',
      inProgress: 'Em andamento',
      done: 'Concluído',
      tableView: 'Tabela',
      boardView: 'Quadro',
      listView: 'Lista',
      calendarView: 'Calendário',
      untitledRow: 'Sem título',
      relatedRows: 'Relacionados',
    },
    blocks: {
      section: 'Bancos de dados',
      table: 'Banco de dados — tabela',
      board: 'Banco de dados — quadro',
      linked: 'Banco de dados vinculado',
      linkedHint: 'Mostre aqui também um banco de dados que você pode ler. São os mesmos dados: as mudanças aparecem em todos os lugares e as pessoas continuam precisando de acesso ao documento dele.',
      searchDatabases: 'Buscar bancos de dados',
      noDatabases: 'Nenhum banco de dados que você pode ler corresponde.',
    },
    section: {
      title: 'Bancos de dados criados neste documento',
      notShown: 'Não exibido no documento',
      insert: 'Mostrar aqui',
    },
    types: {
      TITLE: 'Título',
      TEXT: 'Texto',
      NUMBER: 'Número',
      SELECT: 'Seleção',
      MULTI_SELECT: 'Seleção múltipla',
      STATUS: 'Status',
      DATE: 'Data',
      PERSON: 'Pessoa',
      CHECKBOX: 'Caixa de seleção',
      URL: 'Link',
      RELATION: 'Relação',
    },
    numberFormat: {
      NUMBER: 'Número',
      INTEGER: 'Número inteiro',
      PERCENT: 'Porcentagem',
      BRL: 'Real (R$)',
      USD: 'Dólar americano ($)',
      EUR: 'Euro (€)',
    },
    statusGroup: {
      TODO: 'A fazer',
      IN_PROGRESS: 'Em andamento',
      DONE: 'Concluído',
    },
    property: {
      add: 'Adicionar uma propriedade',
      create: 'Adicionar propriedade',
      name: 'Nome da propriedade',
      type: 'Tipo',
      menu: 'Menu da coluna {{name}}',
      resize: 'Redimensionar {{name}}',
      numberFormat: 'Formato de número',
      editOptions: 'Editar opções',
      editOptionsOf: 'Opções de {{name}}',
      optionColor: 'Cor de {{name}}',
      optionName: 'Nome da opção',
      optionGroup: 'Grupo de status',
      removeOption: 'Remover {{name}}',
      addOption: 'Adicionar uma opção',
      newOption: 'Opção {{n}}',
      removeOptionsConfirm_one: 'Remover {{count}} opção? As células que a usam ficam vazias.',
      removeOptionsConfirm_other: 'Remover {{count}} opções? As células que as usam ficam vazias.',
      hide: 'Ocultar nesta visualização',
      delete: 'Excluir propriedade',
      deleteConfirm: 'Excluir a propriedade “{{name}}” e todos os seus valores?',
      confirmLoss: 'Mudar o tipo mesmo assim?',
      relatedDatabase: 'Banco de dados relacionado',
      thisDatabase: 'Este banco de dados ({{name}})',
      twoWay: 'Mostrar a relação também no outro banco de dados',
    },
    cell: {
      searchOptions: 'Buscar opções',
      searchOrCreate: 'Buscar ou criar uma opção',
      createOption: 'Criar',
      removeOption: 'Remover {{name}}',
      searchPeople: 'Buscar pessoas',
      removePerson: 'Remover {{name}}',
      searchRows: 'Buscar linhas',
      removeRelation: 'Remover {{name}}',
      today: 'Hoje',
      clear: 'Limpar',
      empty: 'Vazio',
    },
    row: {
      new: 'Nova',
      open: 'Abrir',
      openAsPage: 'Abrir como página',
      goToPage: 'Ir para a página',
      insertBelow: 'Inserir linha abaixo',
      delete: 'Excluir linha',
      menu: 'Ações de {{name}}',
      actions: 'Ações da linha',
      edited: 'Última edição de',
    },
    view: {
      tabs: 'Visualizações',
      add: 'Adicionar uma visualização',
      menu: 'Ações da visualização {{name}}',
      rename: 'Renomear visualização',
      renamePrompt: 'Nome da visualização',
      delete: 'Excluir visualização',
      deleteConfirm: 'Excluir a visualização “{{name}}”? As linhas permanecem.',
      properties: 'Propriedades',
      shown: 'Visível',
      hidden: 'Oculta',
      readerChanges: 'Seus filtros e ordenação valem só para você; os editores do documento mudam a visualização salva.',
      kind: {
        TABLE: 'Tabela',
        BOARD: 'Quadro',
        LIST: 'Lista',
        CALENDAR: 'Calendário',
      },
    },
    filter: {
      title: 'Filtrar',
      none: 'Sem filtros: todas as linhas aparecem.',
      where: 'Onde',
      and: 'e',
      property: 'Propriedade do filtro',
      operator: 'Condição',
      value: 'Valor',
      add: 'Adicionar um filtro',
      remove: 'Remover filtro',
      clear: 'Limpar filtros',
      checked: 'Marcada',
      unchecked: 'Desmarcada',
      me: 'Eu',
      op: {
        eq: 'é',
        neq: 'não é',
        contains: 'contém',
        not_contains: 'não contém',
        gt: 'é maior que',
        gte: 'é pelo menos',
        lt: 'é menor que',
        lte: 'é no máximo',
        empty: 'está vazio',
        not_empty: 'não está vazio',
      },
      date: {
        eq: 'é em',
        lt: 'é antes de',
        gt: 'é depois de',
        lte: 'é em ou antes de',
        gte: 'é em ou depois de',
      },
    },
    sort: {
      title: 'Ordenar',
      none: 'Sem ordenação: as linhas mantêm a ordem.',
      property: 'Propriedade da ordenação',
      direction: 'Direção',
      asc: 'Ordem crescente',
      desc: 'Ordem decrescente',
      add: 'Adicionar uma ordenação',
      remove: 'Remover ordenação',
    },
    board: {
      groupBy: 'Agrupar por',
      chooseGroup: 'Escolha a propriedade que forma as colunas.',
      needsGroup: 'Um quadro agrupa as linhas por uma propriedade de seleção, status ou pessoa. Adicione uma para usar esta visualização.',
      none: 'Sem {{name}}',
      label: 'Quadro agrupado por {{name}}',
    },
    calendar: {
      dateProperty: 'Propriedade de data',
      chooseDate: 'Escolha a propriedade de data que posiciona as linhas no calendário.',
      needsDate: 'Um calendário posiciona as linhas por uma propriedade de data. Adicione uma para usar esta visualização.',
      previous: 'Mês anterior',
      next: 'Próximo mês',
      today: 'Hoje',
      by: 'Por {{name}}',
      label: 'Calendário de {{name}}',
      add: 'Adicionar uma linha em {{date}}',
      more: '+{{count}} a mais',
    },
  },
  time: {
    justNow: 'agora mesmo',
  },
};
